import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Navigation, Router, RouterOutlet } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CommonChartmoduleService } from '../Services/common-chartmodule.service';
import { SnapshotService } from '../Services/snapshot.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import { forEach } from 'lodash';

@Component({
  selector: 'app-chart-output',
  templateUrl: './chart-output.component.html',
  styleUrls: ['./chart-output.component.scss'],
})
export class ChartOutputComponent {
  stack100: boolean = false; // Added to fix compile error
stacking: boolean = false;
show100StackChart: boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private routerObj: Router,
    private sanitizer: DomSanitizer,
    private commonChartModule: CommonChartmoduleService,
    private _configService: SnapshotService,
    private _loaderService: LoaderService,
    private clientDetails: SnapshotSharedVariablesService,
    private _configCustomService: CustomsnapshotService,
    private _cdref: ChangeDetectorRef
  ) {
    // this.currentUrl = this.router.url;
  }

  // items: any = [{
  //   customization: 'Data Label : ', func: 'oncheckboxchecked', inputType: 'dropdown', options: [

  //     { value: 'disable', label: 'Off', selected: false },
  //     { value: 'enable', label: 'On', selected: true },

  //   ],
  //   className: "",
  //   id: 'Data Label : '
  // },
  // {
  //   "customization": 'Color :', "func": "oncheckboxchecked", "inputType": "color", "value": "#000000",
  //   className: 'DataLabelGrouping',
  //   id: 'Data Label Color :',
  // },
  // {
  //   customization: 'Property : ',
  //   func: 'oncheckboxchecked',
  //   inputType: 'dropdown',
  //   options: [
  //     { value: 'default', label: 'Default' },
  //     { value: 'changeversus', label: 'Change Versus' },
  //     { value: 'changeversus+significance', label: 'Change Versus + Significance' },
  //     { value: 'significance', label: 'Significance' },
  //     { value: 'significance2', label: 'Significance Level2' },
  //     { value: 'ls', label: 'Low Sample' },
  //   ],
  //   className: 'DataLabelGrouping',
  //   id: 'Data Label Property : ',
  // },
  // ]
  @ViewChild(RouterOutlet, { static: false }) outlet!: RouterOutlet;
  @ViewChild('richTextEditor', { static: false }) richTextEditor!: ElementRef;
  items: any;
  loadedComponent: any;
  userselectedchartdata: any;
  chartTitle: any;
  showExpandPopup = false;
  showDataLabel: boolean = true;
  legendpattern = /Legend../;
  datalabelpattern = /DataLabel../;
  FirstColumnpattern = /FirstColumn../;
  FirstRowpattern = /FirstRow../;
  islegend: boolean = false;
  isdatalabel: boolean = false;
  isFirstColumn:boolean = false;
  isFirstRow:boolean = true;
  widgetTitleText: string = 'Trend Of Metric 2';
  iscustomWidgetIcon: boolean = false;
  customWidgetIcontext: string = '';
  bucketName: string = "";
  showErrorPopUp: boolean = false;
  popUpMessage: string = "";
  errorheaderTitle: string = "";
  selectedValue: any;
  isRefresh: boolean = true;  // Initial value
additionalKPI: any = [];
searchAdditionalKPI: any = ""; 

  chartImagesPreviewList: any = {
    'Vertical Bar Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Bar.png',
    "Vertical Cluster Bar Chart": '',
    "Horizontal Bar Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Bar.png',
    "Horizontal Cluster Bar Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Clustered Bar.png',
    "AREA CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Area Chart.png',
    "LINE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Line chart.png',
    "Vertical Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Vertical lollipop Chart.png',
    "Horizontal Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal lollipop.png',
    "Cluster Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Cluster lollipop.png',
    "01/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 01.png',
    "02/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 02.png',
    "03/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 03.png',
    "04/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 04.png',
    "05/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 05.png',
    "06/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 06.png',
    "07/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 07.png',
    "08/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 08.png',
    "09/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 09.png',
    "10/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 10.png',
    'Scatter Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Scatter Chart.png',
    'Quadrant Scatter Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Quadrant Scatter Chart.png',
    'Bubble Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Bubble Chart.png',
    'Quadrant Bubble Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Quadrant Bubble Chart.png',
    "Vertical Stack Bar": 'assets/ImagesSnapshot/ChartPreviewImages/Vertical Stacked.png',
    "Horizontal Stack Bar": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Stacked.png',
    "01/FUNNEL CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Funnel Chart.png'
  }


  widgetList = [
    {
      widgetName: "Trend of Metric 2",
      visualization: "Trend Chart",
      image: "",
      active: false
    },
    {
      widgetName: "Brand Power Grid",
      visualization: "Bubble Chart",
      image: "https://upload.wikimedia.org/wikipedia/en/a/af/Star_Wars_The_Rise_of_Skywalker_poster.jpg",
      active: false
    },
    {
      widgetName: "Unaided awareness",
      visualization: "01/Pie Chart",
      image: "",
      active: false
    },
    {
      widgetName: "Imagery Statements",
      visualization: "Horizontal Bar",
      image: "",
      active: false
    }

  ]

  chartproperties: any;
  isEditWidget: boolean = false;
  countOfMetricsTobeConfigured: number = 0;
  maxMetricLimit:number=0;
  ngAfterViewInit() {
    const isParentChild = sessionStorage.getItem('isFromParent');
    const savedValue = sessionStorage.getItem('isRefresh');
    const navEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
    if (isParentChild == "true") {
      sessionStorage.setItem('isFromParent', 'false');
      sessionStorage.setItem('isRefresh', 'true');
      const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true };
      sessionStorage.setItem('dataToSend', JSON.stringify(dataToSend));
      sessionStorage.setItem('selectedSnapshotType', JSON.stringify(this._configCustomService.selectedSnapshotType));
      sessionStorage.setItem('selectedSection', this._configCustomService.selectedSection);
      sessionStorage.setItem('selectedSubsection', this._configCustomService.selectedSubsection);
      this.route.paramMap.subscribe((params) => {
        const userData = history.state.userData;
        this.userselectedchartdata = userData; // Use the userData object as needed
        this.chartTitle = this.userselectedchartdata?.selectedChartTitle;
        this.bucketName = this.userselectedchartdata?.routePath.split("/")[0];
      });
      if (this.outlet) {
        this.loadedComponent = this.outlet.component;
      }
      if (this.loadedComponent) {
        // this.items = 
        this.loadedComponent.customization().subscribe((data: any) => {
          // Use the data as needed\\
          data = data.map((item: any) => {
            // Add the selectedValue property
            return {
              ...item,
              selectedValue: '' // or initialize with a default value
            };
          });
          data.forEach((i:any) => {
            if (i.customization === 'Quadrant Color Code : ') {
              i.value = '#808080';
            }
            if(i.customization=='Calculation Logic : '){
              i.selectedValue=i.options.find((l:any)=>l.isSelected).label;
            }
          });

          this.items = data;
           const bdBiToggle = this.items.find((item: any) => item.id === 'BD_BI Toggle');
        if (bdBiToggle) {
          const enabledOption = bdBiToggle.options.find((opt: any) => opt.value === 'enable');
          this.isBrandDependent = enabledOption ? enabledOption.selected : true;
        } else {
          // If BD_BI Toggle is not found, set to undefined to enable both dropdowns
          this.isBrandDependent = undefined;
        }
          
          // Clear Brand dropdown default selection
          const brandDropdown = this.items.find((item: any) => item.id === 'Brand Drop down');
          if (brandDropdown && brandDropdown.options) {
            brandDropdown.options.forEach((option: any) => {
              option.is_selected = false;
              option.selectOrder = 0;
            });
            brandDropdown.checkedList = [];
          }
          
          this.countOfMetricsTobeConfigured = this.items.filter((i: any) => i.customization?.replace(/\s/g, '')?.toLowerCase()?.includes("metric")).length;
          this.maxMetricLimit=this.items.filter((i: any) => i.customization?.replace(/\s/g, '')?.toLowerCase()?.includes("metric"))[0]?.maxMetricLimit;
          let widgetname = this.items.find((i: any) => i.customization?.includes("Widget Name"));
          if (!widgetname) {
            this.widgetTitleText = "Trend Chart";
          }
          this.items.forEach((i: any) => {
            if (i.id == "Metric" && this.chartTitle.toLowerCase()=="funnel chart") {
              i.maxMetricLimit = this.numberofFunnelLevels;
            }
            if (i.id == "Metric" && this.chartTitle.toLowerCase()=="table") {
              i.maxMetricLimit = 10000;
            }
          })
        if (this.userselectedchartdata.widgetEditSelection) {
  if (this.userselectedchartdata.widgetEditSelection?.customizationProperties != "") {
    this.chartproperties = JSON.parse(this.userselectedchartdata.widgetEditSelection?.customizationProperties);
    
    // Check if metric exists before assigning (handles Brand Independent widgets)
    let metricdata = this.userselectedchartdata.widgetEditSelection?.metric;
    if (metricdata && Array.isArray(metricdata) && metricdata.length > 0) {
      this.metric = metricdata;
    } else {
      // Initialize empty metric array for Brand Independent widgets
      this.metric = [];
    }
    
    this.isEditWidget = true;
    this.bindCustomization(this.items);
    
    const bdBiToggleAfterBind = this.items.find((item: any) => item.id === 'BD_BI Toggle');
    if (bdBiToggleAfterBind) {
      const enabledOptionAfterBind = bdBiToggleAfterBind.options.find((opt: any) => opt.value === 'enable');
      this.isBrandDependent = enabledOptionAfterBind ? enabledOptionAfterBind.selected : true;
    } else {
      // If BD_BI Toggle is not found, set to undefined to enable both dropdowns
      this.isBrandDependent = undefined;
    }
  }
}
          else {
            let a = this.items.find((x: any) => x.customization == "Number of Levels : ");
            if (a) {
              a.selectedValue = "4";
            }
            let b = this.items.find((x: any) => x.customization == "First Column as header : ");
            if(b){
              b.checked=true;
            }
            let b1 = this.items.find((x: any) => x.customization == "Column Header Sorting : ");
            if(b1){
              b1.checked=true;
              this.checkbox[b1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = true;
            }
            let b2 = this.items.find((x: any) => x.customization == "Hide NA : ");
            if(b2){
              b2.checked=true;
              this.checkbox[b2.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = true;
            }
            let b3 = this.items.find((x: any) => x.customization == "Freeze First Column : ");
            if(b3){
              b3.checked=true;
              this.checkbox[b3.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = true;
            }
            let b4 = this.items.find((x: any) => x.customization == "Freeze First Row  : ");
            if(b4){
              b4.checked=true;
              this.checkbox[b4.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = true;
            }
          }
        });
      }
    }
    else if (savedValue == "true") {
      if (navEntries && navEntries.length > 0 && navEntries[0].type === 'reload') {
        sessionStorage.setItem('isRefresh', 'false');
        //this.router.navigate(['/Snapshot/configuaration']);
        this._configService.fromBackButton = false;
        this._configCustomService.fromBackButton = false;
        const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: false };
        let refreshData = JSON.parse(sessionStorage.getItem('dataToSend') || "{}");
        // this._configCustomService.selectedSnapshotType=JSON.parse(sessionStorage.getItem('selectedSnapshotType') || "{}");
        // this._configCustomService.selectedSection=sessionStorage.getItem('selectedSection');
        // this._configCustomService.selectedSubsection=sessionStorage.getItem('selectedSubsection');
        this._configCustomService.recievedStatusDataOnBackButtonClick = refreshData;
        this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = false;
        this._configService.ifDataExists = true;
        this.clientDetails.clientDetails = refreshData.clientDetails.clientDetails;
        this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: refreshData } });
      }
      else {
      }
    }

    // Initialize rich text editor content
    setTimeout(() => {
      if (this.richTextEditor && this.customWidgetIcontext) {
        this.setEditorContent(this.customWidgetIcontext);
      }
    }, 100);

  }
  showExpandPopupFun() {

    //this.infoTextTitle = this.widgetName;

    this.showExpandPopup = true;
  }
  hide(data: any) {
    this.showExpandPopup = data;
  }
  getSelectedValue1(item: any) {
    let selectedvalue = item.selectedValue != "" ? item.selectedValue : item.options[0].label;
    return selectedvalue;
  }
  onModelChange(selectedValue: string, item: any) {
    // You can add your custom logic here
    item.selectedValue = selectedValue !== '' ? selectedValue : item.options[0].label;
  }
  bindCustomization(data: any) {
    data.forEach((item1: any) => {
      switch (item1.id) {
        // case "Quadrant Color Code":{
        //   item1.value = this.chartproperties?.dashStyle === "none" ? "#808080" : "#000000"; ;
        //   break;
        // }
              case "Additional KPI": {
          // Bind Additional KPI separately from Metric
          const savedAdditionalKPI = this.userselectedchartdata?.widgetEditSelection?.additionalKPI;
          
          if (savedAdditionalKPI && Array.isArray(savedAdditionalKPI) && savedAdditionalKPI.length > 0) {
            let kpidata = savedAdditionalKPI.find((k: any) => k.kpi_option?.replace(" : ", "") == "Additional KPI");
            
            if (kpidata) {
              if (kpidata.kpi_value && kpidata.kpi_value.length != 0) {
                kpidata.kpi_value = JSON.parse(kpidata.kpi_value[0]);
              }
              
              // Bind saved KPI selections
              if (kpidata.kpi_group == "") {
                let metricsOption = item1.options.find((i: any) => i.option == "METRICS");
                if (metricsOption) {
                  kpidata.kpi_value.forEach((kpi: any) => {
                    metricsOption.Level2.forEach((il2: any) => {
                      if (il2.option == kpi.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = kpi.selectOrder;
                        item1.checkedList.push(kpi);
                      }
                    });
                  });
                }
                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  kpidata.kpi_value.forEach((kpi: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == kpi.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = kpi.selectOrder;
                        item1.checkedList.push(kpi);
                      }
                    });
                  });
                }
              } else {
                // Handle metric group selection
                let metricGroup = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (metricGroup) {
                  metricGroup.Level2.forEach((il2: any) => {
                    if (il2.option == kpidata.kpi_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: kpidata.kpi_group, selectOrder: 0 });
                    }
                  });
                }
              }
            }
          } else {
              item1.checkedList = [];
          }
          break;
        }
         case "BD_BI Toggle": {
        // Bind the saved BD_BI toggle state
        if (this.chartproperties?.bdBiToggle !== undefined) {
          item1.options.forEach((opt: any) => {
            if (opt.value === 'enable') {
              opt.selected = this.chartproperties.bdBiToggle;
            } else {
              opt.selected = !this.chartproperties.bdBiToggle;
            }
          });
          this.isBrandDependent = this.chartproperties.bdBiToggle;
        } else {
          // Default to undefined if not specified to enable both dropdowns
          item1.options.forEach((opt: any) => {
            opt.selected = opt.value === 'enable';
          });
          this.isBrandDependent = undefined;
        }
        break;
      }
        case "Widget Name":
          {
            this.widgetTitleText = this.userselectedchartdata?.widgetEditSelection?.widget_name;
            break;
          }
        case "Info Button":
          {
            this.customWidgetIcontext = this.chartproperties?.infoText;
            break;
          }
        case "Start Value":
          {
            item1.value = this.chartproperties?.startvalue;
            break;
          }
        case "End Value":
          {
            item1.value = this.chartproperties?.endvalue;
            break;
          }
        case "Target Value":
          {
            item1.value = this.chartproperties?.Targetvalue;
            break;
          }
        case "Legend":
          {
            if (this.chartproperties?.showLegend) {
              item1.options.forEach((i: any) => {
                if (i.value == "enable") {
                  i.selected = true
                  this.islegend = false;
                }
                else {
                  i.selected = false
                }
              })
            }
            else {
              item1.options.forEach((i: any) => {
                if (i.value == "disable") {
                  i.selected = true
                  this.islegend = true;
                }
                else {
                  i.selected = false
                }
              })
            }
            break;
          }
        case 'Legend position':
          {
            item1.options.forEach((i: any) => { i.selected = false });
            let option = item1.options.find((m: any) => m.value == this.chartproperties?.legendPosition);
            if (option) {
              option.selected = true;
            };
            break;
          }
        case "Data Label": {
          if (this.chartproperties?.showDataLabel) {
            item1.options.forEach((i: any) => {
              if (i.value == "enable") {
                i.selected = true;
                this.isdatalabel = false;
                this.showDataLabel = true;
              }
              else {
                i.selected = false;
              }
            })
          }
          else {
            item1.options.forEach((i: any) => {
              if (i.value == "disable") {
                i.selected = true;
                this.isdatalabel = true;
                this.showDataLabel = false;
              }
              else {
                i.selected = false;
              }
            })
          }
          break;
        }
        case "Data Label Colour":
          {
            item1.value = this.chartproperties?.dataLabelColor == "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Banded Row":
          {
            item1.value = this.chartproperties?.BannedRow == "" ? "#ffffff" : this.chartproperties?.BannedRow;
            break;
          }
        case "Banded Column":
          {
            item1.value = this.chartproperties?.BannedColumn == "" ? "#ffffff" : this.chartproperties?.BannedColumn;
            break;
          }
        case "Border Colour":
          {
            item1.value = this.chartproperties?.borderColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Column Header Font  Colour":
          {
            item1.value = this.chartproperties?.ColumnHeaderFontColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Row Header Font Colour":
          {
            item1.value = this.chartproperties?.RowHeaderFontColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Column Header Cell  Colour":
          {
            item1.value = this.chartproperties?.ColumnHeaderCellColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Row Header Cell  Colour":
          {
            item1.value = this.chartproperties?.RowHeaderCellColor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Gridlines colour ":
          {
            item1.value = this.chartproperties?.gridlinecolor; //== "default" ? "#000000" : this.chartproperties?.dataLabelColor;
            break;
          }
        case "Data Label Property":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.datalabelStyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Data Label Size":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.dataLabelSize)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Decimal Round off":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.decimalRoundOff)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Marker Style":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.markerStyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Line Style ":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.Linestyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Gridlines dash ":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.gridlinestyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Quadrant Position":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.quadrantPosition)?.label || 'Midpoint of min and max';
            this._cdref.detectChanges();
            // Add fixed value inputs if quadrantPosition is 'fixed'
            if (this.chartproperties?.quadrantPosition === 'fixed') {
              this.updateFixedValueInputs('fixed');
            }
            break;
          }
        case "Fixed X-Axis Value":
          {
            item1.value = this.chartproperties?.fixedXAxisValue || 0;
            break;
          }
        case "Fixed Y-Axis Value":
          {
            item1.value = this.chartproperties?.fixedYAxisValue || 0;
            break;
          }
        case "Quadrant Dash Style ":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.dashStyle)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Quadrant Color Code":
          {
            item1.value = this.chartproperties?.showQuadrantcolor || '#000000';
            break;
          }
        case "Column Header Font Size":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.ColumnHeaderFontSize)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Row Header Font Size":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.RowHeaderFontSize)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Column Header Alignment":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.ColumnHeaderAlignment)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Row Header Alignment":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.RowHeaderAlignment)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Data Label Alignment":
          {
            item1.selectedValue = item1.options.find((i: any) => i.value == this.chartproperties?.RowHeaderAlignment)?.label;
            this._cdref.detectChanges();
            break;
          }
        case "Border Thickness":
          {
            if(this.chartproperties?.borderStyle == "2"){
              item1.selectedValue ="All borders";
            }
            else if(this.chartproperties?.borderStyle == "1"){
              item1.selectedValue ='Outside Border';
            }
            else{
              item1.selectedValue ='No borders';
            }
            this._cdref.detectChanges();
            break;
          }
        case "First Column as header":
          {
            item1.checked = (this.chartproperties?.FirstColumn) ? (this.chartproperties?.FirstColumn) : false;
            this.isFirstColumn = (this.chartproperties?.FirstColumn) ? (!this.chartproperties?.FirstColumn) : true;
            //this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "First Row as header":
          {
            item1.checked = (this.chartproperties?.FirstRow) ? (this.chartproperties?.FirstRow) : false;
            this.isFirstRow = (this.chartproperties?.FirstRow) ? (!this.chartproperties?.FirstRow) : true;
            //this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
      //  case "Trendline in Exports ":
      //     {
      //       item1.checked = (this.chartproperties?.TrendlineinExports) ? (this.chartproperties?.TrendlineinExports) : false;
      //       break;
      //     }
        case "Trendline":
          {
            item1.selectedValue = (this.chartproperties?.Trendline) ? (this.chartproperties?.Trendline) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Column Header Sorting":
          {
            item1.selectedValue = (this.chartproperties?.ColumnHeaderSorting) ? (this.chartproperties?.ColumnHeaderSorting) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Hide NA":
          {
            item1.selectedValue = (this.chartproperties?.HideNA) ? (this.chartproperties?.HideNA) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Highlight Column Total ":
          {
            item1.selectedValue = (this.chartproperties?.HighlightColumnTotal) ? (this.chartproperties?.HighlightColumnTotal) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Highlight  Row Total ":
          {
            item1.selectedValue = (this.chartproperties?.HighlightRowTotal) ? (this.chartproperties?.HighlightRowTotal) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Transpose ":
          {
            item1.selectedValue = (this.chartproperties?.Transpose) ? (this.chartproperties?.Transpose) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Data Label Overlap ":
          {
            item1.selectedValue = (this.chartproperties?.DataLabelOverlap ) ? (this.chartproperties?.DataLabelOverlap) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Axes":
          {
            item1.selectedValue = (this.chartproperties?.Axes) ? (this.chartproperties?.Axes) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Sector fill":
          {
            item1.selectedValue = (this.chartproperties?.Sectorfill) ? (this.chartproperties?.Sectorfill) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Trendline in Exports ":
          {
            item1.selectedValue = (this.chartproperties?.TrendlineinExports) ? (this.chartproperties?.TrendlineinExports) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Freeze First Column":
          {
            item1.selectedValue = (this.chartproperties?.FreezeFirstColumn) ? (this.chartproperties?.FreezeFirstColumn) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Freeze First Row ":
          {
            item1.selectedValue = (this.chartproperties?.FreezeFirstRow) ? (this.chartproperties?.FreezeFirstRow) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Trend Area":
          {
            item1.selectedValue = (this.chartproperties?.TrendArea) ? (this.chartproperties?.TrendArea) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;

            break;
          }
        case "Selected/ All brands":
          {
            item1.selectedValue = (this.chartproperties?.SelectedAllbrands) ? (this.chartproperties?.SelectedAllbrands) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Image Fill":
          {
            item1.selectedValue = (this.chartproperties?.ImageFill) ? (this.chartproperties?.ImageFill) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Sorting":
          {
            item1.selectedValue = (this.chartproperties?.Sorting) ? (this.chartproperties?.Sorting) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Top 10":
          {
            item1.selectedValue = (this.chartproperties?.Top10) ? (this.chartproperties?.Top10) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
         case "100% Stack chart":
          {
            item1.selectedValue = (this.chartproperties["100Stackchart"]) ? (this.chartproperties["100Stackchart"]) : false;
            this.show100StackChart = item1.selectedValue; // Add this line to sync the toggle state
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            
            // Update the options to reflect the saved state
            if (item1.options) {
              item1.options.forEach((opt: any) => {
                if (opt.value === 'enable') {
                  opt.selected = this.show100StackChart;
                } else {
                  opt.selected = !this.show100StackChart;
                }
              });
            }
            break;
          }
        case "Transpose":
          {
            if (this.chartproperties?.StackFormat !== undefined) {
              item1.options.forEach((opt: any) => {
                // Check if the saved value matches the label
                if (opt.label === this.chartproperties.StackFormat) {
                  opt.selected = true;
                } else {
                  opt.selected = false;
                }
              });
              item1.selectedValue = this.chartproperties.StackFormat;
            }
            break;
          }
        case "Stack position":
          {
            item1.selectedValue = (this.chartproperties?.Stackposition) ? (this.chartproperties?.Stackposition) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Axis Image":
          {
            item1.selectedValue = (this.chartproperties?.AxisImage) ? (this.chartproperties?.AxisImage) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Line Style":
          {
            item1.selectedValue = (this.chartproperties?.LineStyle) ? (this.chartproperties?.LineStyle) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "X Axis Gridlines":
          {
            item1.selectedValue = (this.chartproperties?.XAxisGridlines) ? (this.chartproperties?.XAxisGridlines) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Y Axis Gridlines":
          {
            item1.selectedValue = (this.chartproperties?.YAxisGridlines) ? (this.chartproperties?.YAxisGridlines) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Data Label Overlap":
          {
            item1.selectedValue = (this.chartproperties?.DataLabelOverlap) ? (this.chartproperties?.DataLabelOverlap) : false;
            this.checkbox[item1.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = item1.selectedValue;
            break;
          }
        case "Enable data bars(within cells)":
          {
            item1.checked = (this.chartproperties?.enableDataBars) ? (this.chartproperties?.enableDataBars) : false;
            break;
          }
        case "Calculation Logic":
          {
            item1.selectedValue=this.chartproperties?.CalculationLogic;
            item1.options.forEach((l2:any)=>{
              if(l2.value==this.chartproperties?.CalculationLogic){
                l2.isSelected=true;
              }
              else{
                l2.isSelected=false;
              }
              if(l2.value=="None"){
                l2.color=this.chartproperties?.calculationNoneColor;
              }
              if(l2.value=="BIPS"){
                l2.options.forEach((l22:any)=>{
                  if(l22.value=='negativeRange'){
                    l22.inputvalue=this.chartproperties?.bipsNegativeRange;
                    l22.color=this.chartproperties?.bipsNegativeRangeColor;
                  }
                  if(l22.value=='positiveRange'){
                    l22.inputvalue=this.chartproperties?.bipsPositiveRange;
                    l22.color=this.chartproperties?.bipsPositiveRangeColor;
                  }
                })
              }
            })
            
            break;
          }
        case "X Axis Label Orientation":
          {
            item1.options.forEach((i: any) => i.selected = false);
            item1.options.forEach((i: any) => {
              if (i.value == this.chartproperties?.axisLabelOrientation) {
                i.selected = true;
              }
            });
            break;
          }
        case "Y Axis Label Orientation":
          {
            item1.options.forEach((i: any) => i.selected = false);
            item1.options.forEach((i: any) => {
              if (i.value == this.chartproperties?.yaxisLabelOrientation) {
                i.selected = true;
              }
            });
            break;
          }
     case "Metric": {
  // Safely check if metric data exists
  const metricData = this.userselectedchartdata.widgetEditSelection?.metric;
  
  if (metricData && Array.isArray(metricData) && metricData.length > 0) {
    let metricdata = metricData.find((m: any) => m.metric_option.replace(" : ", "") == "Metric");

    if (metricdata) {
      if (metricdata.metric_value.length != 0) {
        metricdata.metric_value = JSON.parse(metricdata.metric_value[0]);
      }
        
           
            // if (item1.select != 3) {
            //   // metricdata.metric_value.forEach((mm: any) => {
            //   //   let it = item1.options.find((i: any) => i.option == mm.option);
            //   //   if (it) {
            //   //     it.isSelected = true;
            //   //     it.selectOrder = mm.selectOrder;
            //   //     it.checked = true;
            //   //     item1.checkedList.push(mm);
            //   //   }
            //   // })
            //   metricdata.metric_value.forEach((mm: any) => {
            //     //let it = item1.options.find((i: any) => i.option == mm.option);
            //     if(mm.typeofmetric!=undefined && mm.typeofmetric!=null){
            //       let it = item1.options.find((i: any) => i.option == mm.typeofmetric);
            //       if(it){
            //         it.Level2.forEach((lev2:any) => {
            //           if(lev2.option == mm.option){
            //             lev2.isSelected = true;
            //             lev2.selectOrder = mm.selectOrder;
            //             if(item1.select == 1){
            //               lev2.checked = true;
            //             }else{
            //               lev2.isSelected = true;
            //             }
            //             item1.checkedList.push(mm);
            //           }
            //         })
            //       }
            //     }
            //   })
            // }
            // else {
              if (metricdata.metric_group == "") {
                let it = item1.options.find((i: any) => i.option == "METRICS");
                if (it) {
                  metricdata.metric_value.forEach((mm: any) => {
                    it.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }

                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  metricdata.metric_value.forEach((mm: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }
              }
              else {
                let it = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (it) {
                  it.Level2.forEach((il2: any) => {
                    if (il2.option == metricdata.metric_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: metricdata.metric_group, selectOrder: 0 });
                    }
                  })

                
              }
            }
          
    } else {
      // Initialize empty checkedList if metric not found
      item1.checkedList = [];
    }
  } 
  break;
}
        case "XAxis Metric": {
          let metricdata = this.userselectedchartdata.widgetEditSelection?.metric.find((m: any) => m.metric_option.replace(" : ", "") == "XAxis Metric");
          if (metricdata) {
            if (metricdata.metric_value.length != 0) {
              metricdata.metric_value = JSON.parse(metricdata.metric_value[0]);
            }
            if (item1.select != 3) {
              // metricdata.metric_value.forEach((mm: any) => {
              //   let it = item1.options.find((i: any) => i.option == mm.option);
              //   if (it) {
              //     it.isSelected = true;
              //     it.selectOrder = mm.selectOrder;
              //     it.checked = true;
              //     item1.checkedList.push(mm);
              //   }
              // })

              metricdata.metric_value.forEach((mm: any) => {
                //let it = item1.options.find((i: any) => i.option == mm.option);
                if(mm.typeofmetric!=undefined && mm.typeofmetric!=null){
                  let it = item1.options.find((i: any) => i.option == mm.typeofmetric);
                  if(it){
                    it.Level2.forEach((lev2:any) => {
                      if(lev2.option == mm.option){
                        lev2.isSelected = true;
                        lev2.selectOrder = mm.selectOrder;
                        if(item1.select == 1){
                          lev2.checked = true;
                        }else{
                          lev2.isSelected = true;
                        }
                        item1.checkedList.push(mm);
                      }
                    })
                  }
                }
              })
            }
            else {
              if (metricdata.metric_group == "") {
                let it = item1.options.find((i: any) => i.option == "METRICS");
                if (it) {
                  metricdata.metric_value.forEach((mm: any) => {
                    it.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }

                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  metricdata.metric_value.forEach((mm: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }
              }
              else {
                let it = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (it) {
                  it.Level2.forEach((il2: any) => {
                    if (il2.option == metricdata.metric_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: metricdata.metric_group, selectOrder: 0 });
                    }
                  })

                }
              }
            }
          }
          break;
        }
        case "YAxis Metric": {
          let metricdata = this.userselectedchartdata.widgetEditSelection?.metric.find((m: any) => m.metric_option.replace(" : ", "") == "YAxis Metric");

          if (metricdata) {
            if (metricdata.metric_value.length != 0) {
              metricdata.metric_value = JSON.parse(metricdata.metric_value[0]);
            }
            if (item1.select != 3) {
              // metricdata.metric_value.forEach((mm: any) => {
              //   let it = item1.options.find((i: any) => i.option == mm.option);
              //   if (it) {
              //     it.isSelected = true;
              //     it.selectOrder = mm.selectOrder;
              //     it.checked = true;
              //     item1.checkedList.push(mm);
              //   }
              // })

              metricdata.metric_value.forEach((mm: any) => {
                //let it = item1.options.find((i: any) => i.option == mm.option);
                if(mm.typeofmetric!=undefined && mm.typeofmetric!=null){
                  let it = item1.options.find((i: any) => i.option == mm.typeofmetric);
                  if(it){
                    it.Level2.forEach((lev2:any) => {
                      if(lev2.option == mm.option){
                        lev2.isSelected = true;
                        lev2.selectOrder = mm.selectOrder;
                        if(item1.select == 1){
                          lev2.checked = true;
                        }else{
                          lev2.isSelected = true;
                        }
                        item1.checkedList.push(mm);
                      }
                    })
                  }
                }
              })
            }
            else {
              if (metricdata.metric_group == "") {
                let it = item1.options.find((i: any) => i.option == "METRICS");
                if (it) {
                  metricdata.metric_value.forEach((mm: any) => {
                    it.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }

                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  metricdata.metric_value.forEach((mm: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }
              }
              else {
                let it = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (it) {
                  it.Level2.forEach((il2: any) => {
                    if (il2.option == metricdata.metric_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: metricdata.metric_group, selectOrder: 0 });
                    }
                  })

                }
              }
            }
          }
          break;
        }
        case "ZAxis Metric": {
          let metricdata = this.userselectedchartdata.widgetEditSelection?.metric.find((m: any) => m.metric_option.replace(" : ", "") == "ZAxis Metric");

          if (metricdata) {
            if (metricdata.metric_value.length != 0) {
              metricdata.metric_value = JSON.parse(metricdata.metric_value[0]);
            }
            if (item1.select != 3) {
              // metricdata.metric_value.forEach((mm: any) => {
              //   let it = item1.options.find((i: any) => i.option == mm.option);
              //   if (it) {
              //     it.isSelected = true;
              //     it.selectOrder = mm.selectOrder;
              //     it.checked = true;
              //     item1.checkedList.push(mm);
              //   }
              // })

              metricdata.metric_value.forEach((mm: any) => {
                //let it = item1.options.find((i: any) => i.option == mm.option);
                if(mm.typeofmetric!=undefined && mm.typeofmetric!=null){
                  let it = item1.options.find((i: any) => i.option == mm.typeofmetric);
                  if(it){
                    it.Level2.forEach((lev2:any) => {
                      if(lev2.option == mm.option){
                        lev2.isSelected = true;
                        lev2.selectOrder = mm.selectOrder;
                        if(item1.select == 1){
                          lev2.checked = true;
                        }else{
                          lev2.isSelected = true;
                        }
                        item1.checkedList.push(mm);
                      }
                    })
                  }
                }
              })
            }
            else {
              if (metricdata.metric_group == "") {
                let it = item1.options.find((i: any) => i.option == "METRICS");
                if (it) {
                  metricdata.metric_value.forEach((mm: any) => {
                    it.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }

                let customMetrics = item1.options.find((i: any) => i.option == "CUSTOM METRICS");
                if (customMetrics) {
                  metricdata.metric_value.forEach((mm: any) => {
                    customMetrics.Level2.forEach((il2: any) => {
                      if (il2.option == mm.option) {
                        il2.isSelected = true;
                        il2.checked = true;
                        il2.selectOrder = mm.selectOrder;
                        item1.checkedList.push(mm);
                      }
                    })
                  })
                }
              }
              else {
                let it = item1.options.find((i: any) => i.option == "METRIC GROUP");
                if (it) {
                  it.Level2.forEach((il2: any) => {
                    if (il2.option == metricdata.metric_group) {
                      il2.isSelected = true;
                      il2.checked = true;
                      item1.checkedList.push({ option: metricdata.metric_group, selectOrder: 0 });
                    }
                  })

                }
              }
            }
          }
          break;
        }
        case "Audience Drop down": {
          // Restore audience selections from saved data
          const savedAudience = this.userselectedchartdata?.widgetEditSelection?.audience;
          if (savedAudience && Array.isArray(savedAudience) && savedAudience.length > 0) {
            item1.checkedList = [];
            savedAudience.forEach((savedItem: any, index: number) => {
              const matchingOption = item1.options.find((opt: any) => 
                opt.option === savedItem.option || opt.variable_label === savedItem.option
              );
              if (matchingOption) {
                matchingOption.is_selected = true;
                matchingOption.selectOrder = index + 1;
                item1.checkedList.push(matchingOption);
              }
            });
            item1.selectOrder = savedAudience.length;
          }
          break;
        }
        case "Brand Drop down": {
          // Restore brand selection from saved data
          const savedBrand = this.userselectedchartdata?.widgetEditSelection?.brand;
          if (savedBrand && Array.isArray(savedBrand) && savedBrand.length > 0) {
            item1.checkedList = [];
            const savedItem = savedBrand[0]; // Brand is single-select
            const matchingOption = item1.options.find((opt: any) => 
              opt.option === savedItem.option || opt.variable_label === savedItem.option
            );
            if (matchingOption) {
              matchingOption.is_selected = true;
              matchingOption.selectOrder = 1;
              item1.checkedList = [matchingOption];
              item1.selectOrder = 1;
            }
          }
          break;
        }
        case "Number of Levels": {
          let a = this.items.find((x: any) => x.customization == "Number of Levels : ");
          let metricdata = this.items.find((x: any) => x.id.toLowerCase() == "metric")
          if (a) {
            a.selectedValue = this.chartproperties?.numberOfFunnelLevels;
            if( this.chartTitle.toLowerCase()=="funnel chart"){
              metricdata.maxMetricLimit=a.selectedValue;
            }  
          }
        }
      }
    })
    // this.items = data;

  }
  onSelectedValueChange(newValue: any, item: any) {
    item.selectedValue = newValue;
  }

  customWidgetIcon(event: any, id: any) {
    if (event.target.value === 'custom' && id == 'Info Button') {
      this.iscustomWidgetIcon = true;
    } else {
      this.iscustomWidgetIcon = false;
    }
  }

  bipsColorChange(event:any,lev2:any,item:any){
    this.loadedComponent[item.func](event,lev2.id+'color');
    lev2.color=event.target.value;
    console.log(item);
  }

  qudarentcolorset(event: any, item: any){
    const colorInput = document.getElementById("Quadrant Color Code : ") as HTMLInputElement;
    if(item.id=="Quadrant Dash Style "){
      if(event.target.value != 'none'){
        colorInput.value = "#000000";
      }else{
        colorInput.value = "#808080";
      }
    }

  }




  cutomDropdownClick(item:any,lev1:any,$event:any){
    item.options.forEach((i:any)=>{
      if(i.value==lev1.value){
        i.isSelected=true;
        $event.target.value=i.value;
        item.selectedValue=i.value;
      }
      else{
        i.isSelected=false;
      }
    })
    this.loadedComponent[item.func]($event,item.id);
  }





  updateitems(checkboxchecked: any, event: any) {
    if(checkboxchecked == '100%Stackchart') {
      var clickedDiv = event.currentTarget as HTMLDivElement;
      var value = clickedDiv.getAttribute('value');
      if (value == 'enable') {
        this.stacking = true;
      }else{
        this.stacking = false;
      }
    }
    if (checkboxchecked == 'DataLabel') {
      var clickedDiv = event.currentTarget as HTMLDivElement;
      var value = clickedDiv.getAttribute('value');
      if (value == 'disable') {
        this.isdatalabel = true;
      } else {
        this.isdatalabel = false;
      }
    }
    if (checkboxchecked == 'Legend') {
      var clickedDiv = event.currentTarget as HTMLDivElement;
      var value = clickedDiv.getAttribute('value');
      if (value == 'disable' || value == 'disabled') {
        this.islegend = true;
      } else {
        this.islegend = false;
      }
    }
    if (checkboxchecked == 'FirstColumn') {
      // var clickedDiv = event.currentTarget as HTMLDivElement;
      // var value = clickedDiv.getAttribute('value');
      if (event.target.checked == true) {
        this.isFirstColumn = false;
       // this.chartproperties.FirstColumn = true;
      } else {
        this.isFirstColumn = true;
       // this.chartproperties.FirstColumn = false;
      }
    //  localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    }
    if (checkboxchecked == 'FirstRow') {
      // var clickedDiv = event.currentTarget as HTMLDivElement;
      // var value = clickedDiv.getAttribute('value');
      if (event.target.checked == true) {
        this.isFirstRow = false;
        //this.chartproperties.FirstRow = true;
      } else {
        this.isFirstRow = true;
        //this.chartproperties.FirstRow = false;
      }
      //localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    }
  }

  shouldDisableImage(item: any, img: any): boolean {
    if (this.datalabelpattern.test(item.className)) {
      return this.isdatalabel ? true : false;
    }
    if (this.legendpattern.test(item.className)) {
      return this.islegend ? true : false;
    }

    return false; // Enable for other cases
  }

  imgOnClick(img: any, $event: any, item: any) {
    this.updateitems(item.className, $event);
    item.options.forEach((element: any) => {
      element.selected = false;
    });
    img.selected = !img.selected;
    this.loadedComponent[item.func]($event, item.id);
  }


getToggleValue(item: any): string {
  if (item.customization.toLowerCase().includes('datalabel') || item.id === 'datalabel') {
    return this.showDataLabel ? 'disable' : 'enable';
  } else if (item.customization.toLowerCase().includes('bd_bi') || item.id === 'bd_bi') {
    return item.selectedValue ? 'enable' : 'disable';
  } else if (item.customization.toLowerCase().includes('transpose') || item.id.toLowerCase().includes('transpose')) {
    return item.selectedValue || 'disable';
  } else if (item.customization.toLowerCase().includes('100%') || item.id === '100% Stack chart') {
    // Check the options directly for accurate state
    const enableOption = item.options?.find((opt: any) => opt.value === 'enable');
    const isEnabled = enableOption ? enableOption.selected : this.show100StackChart;
    return isEnabled ? 'enable' : 'disable';
  }
  return '';
}


getToggleClass(item: any): string {
  if (item.customization.toLowerCase().includes('datalabel') || item.id === 'datalabel') {
    return this.showDataLabel ? 'label-toggle-left' : 'label-toggle-right';
  } else if (item.customization.toLowerCase().includes('bd_bi') || item.id === 'bd_bi') {
    return item.selectedValue ? 'label-toggle-left' : 'label-toggle-right';
  } else if (item.customization.toLowerCase().includes('transpose') || item.id.toLowerCase().includes('transpose')) {
    return item.selectedValue === 'On' ? 'label-toggle-left' : 'label-toggle-right';
  } else if (item.customization.toLowerCase().includes('100%') || item.id === '100% Stack chart') {
    // Check the options directly for accurate state
    const enableOption = item.options?.find((opt: any) => opt.value === 'enable');
    const isEnabled = enableOption ? enableOption.selected : this.show100StackChart;
    return isEnabled ? 'label-toggle-left' : 'label-toggle-right';
  }
  return '';
}



toggleClick(item: any, img: any, event: any): void {
  if (item.customization.toLowerCase().includes('data label') || item.id === 'data label') {
    this.datalabelToggleClick(item, event);
  } else if (item.customization.toLowerCase().includes('bd_bi') || item.id === 'bd_bi') {
    this.bdBiToggleClick(item, img, event);
  } else if (item.customization.toLowerCase().includes('transpose') || item.id.toLowerCase().includes('transpose')) {
    this.stackFormatToggleClick(item, img, event);
  }
  else if (item.customization.toLowerCase().includes('100%') || item.id === '100% Stack chart') {
    this.stack100ToggleClick(item, event);
  }
}



stack100ToggleClick(item: any, $event: any): void {
  // First, determine the current state from options (not from show100StackChart)
  const enableOption = item.options.find((opt: any) => opt.value === 'enable');
  const currentState = enableOption ? enableOption.selected : false;
  
  // Toggle to the opposite state
  const newState = !currentState;
  
  // Update options
  item.options.forEach((m: any) => {
    if (m.value === 'enable') {
      m.selected = newState;
    } else {
      m.selected = !newState;
    }
  });
  
  // Sync the component state
  this.show100StackChart = newState;
  
  // Set the event value for the chart component
  $event.target.value = newState;
  
  // Update the selectedValue for persistence
  item.selectedValue = newState;
  
  // Save to checkbox object for persistence
  this.checkbox[item.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = newState;
   this.updateitems(item.className, $event);
  // Call the component function to apply changes
  if (this.loadedComponent && this.loadedComponent[item.func]) {
    this.loadedComponent[item.func]($event, item.id);
  }
}




stackChartToggleClick(item: any, img: any, $event: any): void {
  item.options.forEach((option: any) => {
    option.selected = false;
  });
  img.selected = true;
  
  // Store the selected value
  item.selectedValue = img.value;
  
  // Save to checkbox object for persistence
  this.checkbox[item.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = img.value;
  
  // Update items and call component function
  this.updateitems(item.className, $event);
  
  if (this.loadedComponent && this.loadedComponent[item.func]) {
    this.loadedComponent[item.func]($event, item.id);
  }
}

stackFormatToggleClick(item: any, img: any, event: any): void {
  // Handle stack format toggle logic
  item.options.forEach((option: any) => {
    option.selected = false;
  });
  img.selected = true;
  
  // Store the selected label (like 'Metric' or 'Brand/Cat/Market/ Audience')
  item.selectedValue = img.label;
  
  // Save to checkbox object for persistence - save the label instead of value
  this.checkbox[item.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = img.label;
  
  // Call the existing customization function if it exists
  if (this.loadedComponent && this.loadedComponent[item.func]) {
    this.loadedComponent[item.func](event, item.id);
  }
}

// Add your bd_bi toggle handler
bdBiToggleClick(item: any, img: any, event: any): void {
  // Handle bd_bi toggle logic here
  item.options.forEach((option: any) => {
    option.selected = false;
  });
  img.selected = true;

  // Check if this is BD_BI Toggle
  if (item.id === 'BD_BI Toggle') {
    this.isBrandDependent = img.value === 'enable'; // 'enable' = Brand Dependent, 'disable' = Brand Independent
  }

  // Call the existing customization function
  this.loadedComponent[item.func]?.(event, item.id);
  // Call any additional logic needed
}


isBrandDependent: boolean | undefined = true; // Add this property



searchAudience: string = '';
searchBrand: string = '';

toggleAudienceDropdown(item: any, isMouseLeave: boolean) {
  if (item.id === 'Audience Drop down') {
    if (isMouseLeave) {
      item.showDropdown = false;
    } else {
      item.showDropdown = !item.showDropdown;
      
      // Sort options when opening dropdown: selected items first in selection order
      if (item.showDropdown && item.options) {
        item.options.sort((a: any, b: any) => {
          const aSelected = a.is_selected ? 1 : 0;
          const bSelected = b.is_selected ? 1 : 0;
          const aOrder = a.selectOrder || 0;
          const bOrder = b.selectOrder || 0;
          
          // Selected items come first
          if (aSelected !== bSelected) {
            return bSelected - aSelected;
          }
          
          // Among selected items, sort by selection order
          if (aSelected && bSelected && aOrder !== bOrder) {
            return aOrder - bOrder;
          }
          
          // Unselected items maintain original order
          return 0;
        });
      }
    }
  } else if (item.id === 'Brand Drop down') {
    if (isMouseLeave) {
      item.showDropdown = false;
    } else {
      item.showDropdown = !item.showDropdown;
      
      // Sort options when opening dropdown: selected item first
      if (item.showDropdown && item.options) {
        item.options.sort((a: any, b: any) => {
          const aSelected = a.is_selected ? 1 : 0;
          const bSelected = b.is_selected ? 1 : 0;
          
          // Selected item comes first
          if (aSelected !== bSelected) {
            return bSelected - aSelected;
          }
          
          // Unselected items maintain original order
          return 0;
        });
      }
    }
  }
}

resetAudienceSelections(item: any, options: any[]) {
  options.forEach((option: any) => {
    option.is_selected = false;
    option.selectOrder = 0;
  });
  item.checkedList = [];
  item.selectOrder = 0;
  
  if (item.id === 'Audience Drop down') {
    this.searchAudience = '';
  } else if (item.id === 'Brand Drop down') {
    this.searchBrand = '';
  }
}
getSelectedAudienceValue(audience: any, option: string, item: any) {
  if (item.id === 'Brand Drop down') {
    // Brand Drop down - single selection (radio button)
    item.options.forEach((aud: any) => {
      aud.is_selected = false;
      aud.selectOrder = 0;
    });
    
    audience.is_selected = true;
    audience.selectOrder = 1;
     item.checkedList = [{
      option: option,
      selectOrder: 1,
      value: audience.value,
      data: audience.data,
      index: audience.index
    }];
  } else {
    // Audience Drop down - multiple selection with limit
    const maxAudienceLimit = item.maxAudienceLimit || 6;
    
    // Check if we're at the limit before allowing selection
    if (!audience.is_selected && item.checkedList.length >= maxAudienceLimit) {
      return; // Don't allow more selections if at limit
    }

    audience.is_selected = !audience.is_selected;
    
    if (audience.is_selected) {
      // Add to checkedList
      const maxSelectOrder = item.checkedList.length > 0 
        ? Math.max(...item.checkedList.map((a: any) => a.selectOrder))
        : 0;
      
      audience.selectOrder = maxSelectOrder + 1;
     item.checkedList.push({ 
        option: option,
        selectOrder: audience.selectOrder,
        value: audience.value,  // Add value
        is_selected: true,      // Add is_selected
        index: audience.index,  // Add index
        data: audience.data     // ✅ Add complete data object
      });
    } else {
      // Remove from checkedList and re-order
      item.checkedList = item.checkedList.filter((aud: any) => aud.option !== option);
      
      // Re-order remaining items
      item.checkedList.forEach((aud: any, idx: number) => {
        aud.selectOrder = idx + 1;
      });
      
      // Update selectOrder in options
      item.options.forEach((opt: any) => {
        const found = item.checkedList.find((c: any) => c.option === opt.option);
        if (found) {
          opt.selectOrder = found.selectOrder;
        } else {
          opt.selectOrder = 0;
        }
      });
      
      audience.selectOrder = 0;
    }
  }
  
  // Apply customization if needed
  this.loadedComponent[item.func]?.(audience, item);
}


  datalabelToggleClick(item: any, $event: any) {
    item.options.forEach((m: any) => (m.selected = !m.selected));
    this.showDataLabel = !this.showDataLabel;
    $event.target.value = this.showDataLabel;
    this.updateitems(item.className, $event);
    this.loadedComponent[item.func]($event, item.id);
  }

  onInputChange(event: any) {
    this.widgetTitleText = event.target.value;
    if (this.widgetTitleText == '') {
      this.widgetTitleText = 'Trend Of Metric 2';
    }
  }

  goback() {
    this._configService.fromBackButton = true;
    this._configCustomService.fromBackButton = true;
    const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true };
    this._configCustomService.recievedStatusDataOnBackButtonClick = dataToSend;
    this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: dataToSend } });
  }
  getCustomization(item: any): SafeHtml {
    let modifiedCustomization = item.customization.toString();
    if (modifiedCustomization.includes('#')) {
      modifiedCustomization = modifiedCustomization.replace(
        /#/,
        `<sup style="color:red !important;font-size:0.7em !important;">(#)</sup>`
      );
    }
    if (modifiedCustomization.includes('*')) {
      modifiedCustomization = modifiedCustomization.replace(
        /\*/g,
        '<sup style="color:red !important;font-size:0.7em !important;">(*)</sup>'
      );
    }
    // Check if 'Grouping' is present in the class name
    if (item.className.includes('Grouping')) {
      // Add indentation if not already present
      if (
        !modifiedCustomization.startsWith('<span style="margin-left: 2em;">')
      ) {
        // modifiedCustomization = `<span style="margin-left: 2em;">${modifiedCustomization}</span>`;
      }
    }
    return this.sanitizer.bypassSecurityTrustHtml(modifiedCustomization);
  }

  showDropDown = false;
  checkedList: any = [];
  // getSelectedValue(status:Boolean,value:String,select:any){
  //   if(status){
  //     this.checkedList.push(value);
  //   }else{
  //       var index = this.checkedList.indexOf(value);
  //       this.checkedList.splice(index,1);
  //   }
  // }
  metric: any = [];
  searchmetric: any = "";
  getSelectedValue(
    option: any,
    value: string,
    item: any,
    lev1: any = []
  ): void {
  if (item.id === 'Additional KPI') {
      lev1.Level2.forEach((l2: any) => {
          if (l2 == option) {
            l2.isSelected = true;
            l2.checked = true;
            l2.selectOrder = 1;
          }
          else {
            l2.isSelected = false;
            l2.checked = false;
            l2.selectOrder = 0;
          }
        });
  
  // Select only the current option
  item.checkedList = [{ option: value, selectOrder: option.selectOrder, type: lev1.option }];
        item.options.forEach((i: any) => {
          if (i != lev1) {
            i.Level2.forEach((ii: any) => {
              ii.isSelected = false;
              ii.checked = false;
              ii.selectOrder = 0;
            })
          }
        })

        
  let existingKPI = this.additionalKPI.find((k: any) => k.kpi_option == item.customization);
  if (existingKPI) {
    existingKPI.kpi_value = item.checkedList;
  } else {
    this.additionalKPI.push({
      kpi_option: item.customization,
      kpi_value: item.checkedList,
      kpi_group: ""
    });
  }
  return;
}
  else{ 
     if (item.select === 1) {
      option.checked = option.checked == null ? true : !option.checked;
      option.selectOrder = 1;
      // If select === 1, treat the checkbox as a radio button
      if (option.checked) {
        // Uncheck previously selected items
        item.checkedList = [{ option: value, selectOrder: option.selectOrder,typeofmetric:lev1.option }];
        // item.options.forEach((m: any) => {
        //   if (m != option) {
        //     m.checked = false;
        //     m.selectOrder = 0;
        //   }
        // });

        item.options.forEach((m: any) => {
          m.Level2.forEach((lev2:any) => {
            if (lev2 != option) {
              lev2.checked = false;
              lev2.selectOrder = 0;
            }
          })
        });
      } else {
        // If the radio button is unchecked, remove it from the checkedList
        item.checkedList = [];
      }
      let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
      if (existingmetric) {
        existingmetric.metric_value = item.checkedList;
      }
      else {
        this.metric.push({
          metric_option: item.customization,
          metric_value: item.checkedList,
          metric_group: ""
        })
      }
    }
    else if (item.select === 2) {
      //const maxSelectOrder = item.options.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0);
      let metrics = item.options.filter((m:any) => m.option != "METRIC GROUP");
      let maxSelectOrder = 0;
      metrics.forEach((m:any)=>{
        maxSelectOrder = Math.max(m.Level2.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0), maxSelectOrder);
      })

      // For multiple select checkboxes
      // option.checked = option.checked == null ? true : !option.checked;
      // if (option.checked) {
      //   // If checkbox is checked, add value to checkedList
      //   option.selectOrder = maxSelectOrder + 1;
      //   item.checkedList.push({ option: value, selectOrder: option.selectOrder });
      // } else {
      //   // If checkbox is unchecked, remove value from checkedList
      //   item.options.forEach((i: any) => {
      //     if (i.selectOrder > option.selectOrder) {
      //       i.selectOrder -= 1;
      //     }
      //   })
      //   option.selectOrder = 0;
      //   let v = item.checkedList.find((i: any) => i.option == value);
      //   let index = -1;
      //   if (v) { index = item.checkedList.indexOf(v); }
      //   if (index !== -1) {
      //     item.checkedList.splice(index, 1);
      //   }
      // }

      option.isSelected = option.isSelected == null ? true : !option.isSelected;
      lev1.Level2.forEach((l2: any) => {
      if (l2 == option) {
          if (option.isSelected) {
            option.selectOrder = maxSelectOrder + 1;
            item.checkedList.push({ option: value, selectOrder: option.selectOrder,typeofmetric:lev1.option });
          }
          else {
            // lev1.Level2.forEach((i: any) => {
            //   if (i.selectOrder > option.selectOrder) {
            //     i.selectOrder -= 1;
            //   }
            // })

            item.options.forEach((it:any) => {
              if(it.option != "METRIC GROUP"){
                it.Level2.forEach((lev2:any) => {
                  if(lev2.selectOrder > option.selectOrder) {
                    item.checkedList.forEach( (i:any) => {
                      if(i.option == lev2.option){
                        i.selectOrder -= 1;       
                      }
                    })
                    lev2.selectOrder -= 1;
                  }
                })
              }
            })

            option.selectOrder = 0;
            let v = item.checkedList.find((i: any) => i.option == value);
            let index = -1;
            if (v) { index = item.checkedList.indexOf(v); }
            if (index !== -1) {
              item.checkedList.splice(index, 1);
            }
          }
        }
      })
      
      let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
      if (existingmetric) {
        existingmetric.metric_value = item.checkedList;
      }
      else {
        this.metric.push({
          metric_option: item.customization,
          metric_value: item.checkedList,
          metric_group: ""
        })
      }
    }
    else if (item.select === 3) {
      // For radio buttons - check both lev1.option == "METRIC GROUP" OR lev1.type == 'radio'
      if (lev1.option == "METRIC GROUP" || lev1.type == 'radio') {
        // Radio button behavior - only one selection allowed
        lev1.Level2.forEach((l2: any) => {
          if (l2 == option) {
            l2.isSelected = true;
            l2.checked = true;
            l2.selectOrder = 1;
          }
          else {
            l2.isSelected = false;
            l2.checked = false;
            l2.selectOrder = 0;
          }
        });
        item.checkedList = [{ option: value, selectOrder: option.selectOrder, type: lev1.option }];
        item.options.forEach((i: any) => {
          if (i != lev1) {
            i.Level2.forEach((ii: any) => {
              ii.isSelected = false;
              ii.checked = false;
              ii.selectOrder = 0;
            })
          }
        })
        let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
        if (existingmetric) {
          existingmetric.metric_value = [];
          // item.checkedList = [];
          existingmetric.metric_group = value;
        }
        else {
          this.metric.push({
            metric_option: item.customization,
            metric_value: [],
            metric_group: value
          })
        }
      }
      if (lev1.option == "METRICS" || lev1.option == "CUSTOM METRICS") {

        let metrics = item.options.filter((m:any) => m.option != "METRIC GROUP");
        let maxSelectOrder = 0;
        metrics.forEach((m:any)=>{
          maxSelectOrder = Math.max(m.Level2.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0), maxSelectOrder);
        })
        //const maxSelectOrder = lev1.Level2.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0);
        

        // if (maxSelectOrder == 0) {
        //   item.checkedList = [];
        // }
        if(maxSelectOrder == 0){
          item.checkboxlist = [];
        }

        // item.options.forEach((i: any) => {
        //   if (i != lev1) {
        //     i.Level2.forEach((ii: any) => {
        //       ii.isSelected = false;
        //     })
        //   }
        // });

        let removeMetrics : any[] = [];
        item.options.forEach((i: any) => {
          if (i.option == "METRIC GROUP") {
            i.Level2.forEach((ii: any) => {
              if(ii.isSelected){
                removeMetrics.push({
                  option: ii.option,
                  selectOrder : ii.selectOrder,
                })
              }
              ii.isSelected = false;
            })
          }
        });
        option.isSelected = option.isSelected == null ? true : !option.isSelected;
        lev1.Level2.forEach((l2: any) => {
          if (l2 == option) {
            if (option.isSelected) {
              option.selectOrder = maxSelectOrder + 1;
              item.checkedList.push({ option: value, selectOrder: option.selectOrder,typeofmetric:lev1.option });
            }
            else {

              item.options.forEach((it:any) => {
                if(it.option != "METRIC GROUP"){
                  it.Level2.forEach((lev2:any) => {
                    if(lev2.selectOrder > option.selectOrder) {

                      item.checkedList.forEach( (i:any) => {
                        if(i.option == lev2.option){
                          i.selectOrder -= 1;       
                        }
                      })
                      lev2.selectOrder -= 1;
                    }
                  })
                }
              })
              // lev1.Level2.forEach((i: any) => {
              //   if (i.selectOrder > option.selectOrder) {
              //     i.selectOrder -= 1;
              //   }
              // })
              option.selectOrder = 0;
              let v = item.checkedList.find((i: any) => i.option == value);
              let index = -1;
              if (v) { index = item.checkedList.indexOf(v); }
              if (index !== -1) {
                item.checkedList.splice(index, 1);
              }
            }
          }
        })

        item.checkedList = item.checkedList.filter( (it:any) => !removeMetrics.some((remove:any) => 
          remove.option === it.option && remove.selectOrder === it.selectOrder
        ));

        let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
        if (existingmetric) {
          existingmetric.metric_value = item.checkedList;
        }
        else {
          this.metric.push({
            metric_option: item.customization,
            metric_value: item.checkedList,
            metric_group: ""
          })
        }
      }
    }
 

    else if (item.select === 4) {
      // For multiple select with limit (Audience Snapshot)
      
      // Check if this is a METRIC GROUP selection (radio behavior)
      if (lev1.option == "METRIC GROUP") {
        // Radio button behavior - only one selection allowed from METRIC GROUP
        lev1.Level2.forEach((l2: any) => {
          if (l2 == option) {
            l2.isSelected = true;
            l2.checked = true;
            l2.selectOrder = 1;
          }
          else {
            l2.isSelected = false;
            l2.checked = false;
            l2.selectOrder = 0;
          }
        });
        
        // Update checkedList for display purposes only
        item.checkedList = [{ option: value, selectOrder: 1, type: lev1.option }];
        
        // Clear other options (METRICS and CUSTOM METRICS)
        item.options.forEach((i: any) => {
          if (i != lev1 && i.option != "METRIC GROUP") {
            i.Level2.forEach((ii: any) => {
              ii.isSelected = false;
              ii.checked = false;
              ii.selectOrder = 0;
            })
          }
        })
        
        // Store in metric_group, NOT in metric_value
        let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
        if (existingmetric) {
          existingmetric.metric_value = []; // Clear metric_value
          existingmetric.metric_group = value; // Store the selected group name
        }
        else {
          this.metric.push({
            metric_option: item.customization,
            metric_value: [], // Empty array
            metric_group: value // Store the selected group name
          })
        }
      }
      else if (lev1.type == 'radio' && (lev1.option == "METRICS" || lev1.option == "CUSTOM METRICS")) {
        // Radio button behavior for METRICS/CUSTOM METRICS - single selection, store in metric_value
        
        // Clear METRIC GROUP selections
        item.options.forEach((i: any) => {
          if (i.option == "METRIC GROUP") {
            i.Level2.forEach((ii: any) => {
              ii.isSelected = false;
              ii.checked = false;
              ii.selectOrder = 0;
            })
          }
        });
        
        // Radio behavior within the current option group - only one selection
        lev1.Level2.forEach((l2: any) => {
          if (l2 == option) {
            l2.isSelected = true;
            l2.checked = true;
            l2.selectOrder = 1;
          }
          else {
            l2.isSelected = false;
            l2.checked = false;
            l2.selectOrder = 0;
          }
        });
        
        // Clear selections from other option groups (METRICS or CUSTOM METRICS)
        item.options.forEach((i: any) => {
          if (i != lev1 && i.option != "METRIC GROUP") {
            i.Level2.forEach((ii: any) => {
              ii.isSelected = false;
              ii.checked = false;
              ii.selectOrder = 0;
            })
          }
        });
        
        // Update checkedList for display
        item.checkedList = [{ option: value, selectOrder: 1, typeofmetric: lev1.option }];
        
        // Store in metric_value, clear metric_group
        let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
        if (existingmetric) {
          existingmetric.metric_value = item.checkedList;
          existingmetric.metric_group = ""; // Clear metric_group
        }
        else {
          this.metric.push({
            metric_option: item.customization,
            metric_value: item.checkedList,
            metric_group: "" // Empty string
          })
        }
      }
      else if (lev1.option == "METRICS" || lev1.option == "CUSTOM METRICS") {
        // Multiple select with limit for METRICS/CUSTOM METRICS (checkbox behavior)
        let metrics = item.options.filter((m:any) => m.option != "METRIC GROUP");
        let maxSelectOrder = 0;
        metrics.forEach((m:any)=>{
          maxSelectOrder = Math.max(m.Level2.reduce((max: any, item: any) => (item.selectOrder > max ? item.selectOrder : max), 0), maxSelectOrder);
        })

        // If coming from METRIC GROUP, reset the maxSelectOrder
        if (maxSelectOrder == 0) {
          item.checkedList = [];
        }

        // Clear METRIC GROUP selections when selecting from METRICS/CUSTOM METRICS
        let removeMetrics: any[] = [];
        item.options.forEach((i: any) => {
          if (i.option == "METRIC GROUP") {
            i.Level2.forEach((ii: any) => {
              if (ii.isSelected || ii.checked) {
                removeMetrics.push({
                  option: ii.option,
                  selectOrder: ii.selectOrder,
                })
              }
              ii.isSelected = false;
              ii.checked = false;
              ii.selectOrder = 0;
            })
          }
        });

        // Check if we're at the limit before allowing selection
        if (!option.isSelected && item.checkedList.length >= item.maxMetricLimit) {
          // Already at max limit, don't allow more selections
          return;
        }

        option.isSelected = option.isSelected == null ? true : !option.isSelected;
        lev1.Level2.forEach((l2: any) => {
          if (l2 == option) {
            if (option.isSelected) {
              option.selectOrder = maxSelectOrder + 1;
              item.checkedList.push({ option: value, selectOrder: option.selectOrder, typeofmetric: lev1.option });
            }
            else {
              item.options.forEach((it:any) => {
                if(it.option != "METRIC GROUP"){
                  it.Level2.forEach((lev2:any) => {
                    if(lev2.selectOrder > option.selectOrder) {
                      item.checkedList.forEach( (i:any) => {
                        if(i.option == lev2.option){
                          i.selectOrder -= 1;       
                        }
                      })
                      lev2.selectOrder -= 1;
                    }
                  })
                }
              })

              option.selectOrder = 0;
              let v = item.checkedList.find((i: any) => i.option == value);
              let index = -1;
              if (v) { index = item.checkedList.indexOf(v); }
              if (index !== -1) {
                item.checkedList.splice(index, 1);
              }
            }
          }
        })

        // Remove METRIC GROUP items from checkedList
        item.checkedList = item.checkedList.filter((it: any) => !removeMetrics.some((remove: any) =>
          remove.option === it.option && remove.selectOrder === it.selectOrder
        ));
        
        // Store in metric_value, clear metric_group
        let existingmetric = this.metric.find((m: any) => m.metric_option == item.customization);
        if (existingmetric) {
          existingmetric.metric_value = item.checkedList;
          existingmetric.metric_group = ""; // Clear metric_group
        }
        else {
          this.metric.push({
            metric_option: item.customization,
            metric_value: item.checkedList,
            metric_group: "" // Empty string
          })
        }
      }
    }


  }
  }
  widgetDetails: any;
  fromSave = false;
  checkbox: any = {};
  previousnumberofFunnelLevels = 4;
  numberofFunnelLevels = 4;
  showConfirmationPopUp: boolean = false;
  callCustomization($event: any, item: any) {
    if (item.customization !== "Number of Levels : ") {
      this.loadedComponent[item.func]($event, item.id);
      // Handle Quadrant Position change to dynamically show/hide fixed value inputs
      if (item.id === 'Quadrant Position' || item.customization?.toLowerCase().includes('quadrant position')) {
        const selectedValue = $event.target.value;
        this.updateFixedValueInputs(selectedValue);
      }
    }
    else {
      this.numberofFunnelLevels = Number($event.target.value);
      this.items.forEach((i: any) => {
        if (i.id == "Number of Levels") {
          i.selectedValue = this.previousnumberofFunnelLevels;
        }
      });
      this._cdref.detectChanges();
      this.showConfirmationPopUp = true;
      this.errorheaderTitle = "Confirmation";
      this.popUpMessage = "Changing the funnel level would reset the metrics. Are you sure you want to proceed?"
    }
  }

  /**
   * Dynamically adds or removes Fixed X-Axis Value and Fixed Y-Axis Value inputs
   * based on the Quadrant Position selection.
   * - When 'fixed' is selected: Adds two number input fields after Quadrant Position dropdown
   * - When other options selected: Removes the fixed value inputs
   * @param quadrantPosition - The selected quadrant position value ('fixed', 'average', or 'midpoint')
   */
  updateFixedValueInputs(quadrantPosition: string) {
    // Remove existing fixed value inputs first
    this.items = this.items.filter((item: any) => 
      item.customization !== 'Fixed X-Axis Value : ' && 
      item.customization !== 'Fixed Y-Axis Value : '
    );

    // Add fixed value inputs only if 'fixed' is selected
    if (quadrantPosition === 'fixed') {
      // Find Quadrant Position dropdown index using flexible matching
      const quadrantPositionIndex = this.items.findIndex((item: any) => 
        item.customization?.toLowerCase().includes('quadrant position')
      );
      
      if (quadrantPositionIndex !== -1) {
        // Create Fixed X-Axis Value input item
        const fixedXAxisItem = {
          customization: 'Fixed X-Axis Value : ',
          func: 'applycustomization',
          inputType: 'text',
          className: '',
          id: 'Fixed X-Axis Value',
          value: this.chartproperties?.fixedXAxisValue || 0
        };
        
        // Create Fixed Y-Axis Value input item
        const fixedYAxisItem = {
          customization: 'Fixed Y-Axis Value : ',
          func: 'applycustomization',
          inputType: 'text',
          className: '',
          id: 'Fixed Y-Axis Value',
          value: this.chartproperties?.fixedYAxisValue || 0
        };
        
        // Insert after Quadrant Position dropdown
        this.items.splice(quadrantPositionIndex + 1, 0, fixedXAxisItem, fixedYAxisItem);
      } else {
        // Fallback: add at the end if Quadrant Position not found
        this.items.push({
          customization: 'Fixed X-Axis Value : ',
          func: 'applycustomization',
          inputType: 'text',
          className: '',
          id: 'Fixed X-Axis Value',
          value: this.chartproperties?.fixedXAxisValue || 0
        });
        this.items.push({
          customization: 'Fixed Y-Axis Value : ',
          func: 'applycustomization',
          inputType: 'text',
          className: '',
          id: 'Fixed Y-Axis Value',
          value: this.chartproperties?.fixedYAxisValue || 0
        });
      }
    }
    
    this._cdref.detectChanges();
  }

  onConfirmationClick($event: any) {
    this.previousnumberofFunnelLevels = this.numberofFunnelLevels;
    this.showConfirmationPopUp = false;
    this.items.forEach((i: any) => {
      if (i.id == "Number of Levels") {
        i.selectedValue = this.previousnumberofFunnelLevels;
      }
      if (i.id == "Metric") {
        if(i.options) {
          i.options.forEach((o: any) => {
            this.resetSelections(i, i.options, o);
          });
        }
        i.checkedList = [];
        this.metric = [];
        i.maxMetricLimit = this.numberofFunnelLevels;
        this.loadedComponent[i.func](this.numberofFunnelLevels, "Number of Levels");
      }
    });
  }

  checkBoxesClicked(event: any, item: any) {
    item.checked = event.target.checked;
    this.checkbox[item.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = event.target.checked;
  }

  OutsidecheckBoxesClicked($event: any, item: any) {
    item.checked = $event.target.checked;
    //this.checkbox[item.customization.replace(" : ", "").replace(/\s+/g, '').replace("/", "").replace("%", "")] = event.target.checked;
    this.updateitems(item.className, $event);
    this.loadedComponent[item.func]($event, item.id);
  }

  restrictInput(event: KeyboardEvent,$event1: any,item: any) {
    const char = event.key;
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const cursorPos = input.selectionStart ?? 0;

    // Allow navigation keys
    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
      return;
    }

    // Only one "-" allowed at the beginning
    if (char === '-') {
      // allow only if cursor is at position 0 and "-" does not already exist
      if (cursorPos === 0 && !currentValue.includes('-')) {
        return;
      }
      event.preventDefault();
      return;
    }

    // Allow only one "."
    if (char === '.') {
      if (currentValue.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    // Allow digits only
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault();
    }
  }

  validateNumber(event: any, item: any, inputElement: any) {
    let value = event.target.value;
    // Remove invalid characters except digits, "-", and "."
    value = value.replace(/[^0-9\.\-]/g, '');
    event.target.value = value; // Keep typed value

    // When empty input, apply default logic
    if (value === "") {
      if (item.id === 'Start Value') {
        event.value = 0;
        event.target.value = "";
      } else if (item.id === 'End Value') {
        event.value = 100;
        event.target.value = "";
      } else if (item.id === 'Target Value') {
        event.value = 0;
        event.target.value = "";
      }
      this.loadedComponent[item.func](event, item.id);
      return;
    }

    if (isNaN(value)) {
      return;
    }
     
    if (Number(value) > 100) {
      value = Math.min(Number(value), 100);
      event.target.value = value; // update in textarea
    }

    event.value = value;
    this.loadedComponent[item.func](event, item.id);
  }

  additonalfeatureStatus() {
    const trueEntries = Object.entries(this.checkbox).filter(([key, value]) => value === true);
    const trueCount = trueEntries.length;

    switch (trueCount) {
      case 0:

        return "Select";

      case 1:
        const [keyOfSingleTrue] = trueEntries[0]; // Extract the key from the single true entry
        return keyOfSingleTrue;
      // You can use `keyOfSingleTrue` here as needed

      default:
        return "Multiple";
    }

  }

  @Output() customSaveData = new EventEmitter<any>();
  saveCurrentWidget() {
    // Only process if metric array exists and has items
if (this.metric && this.metric.length > 0) {
  this.metric.forEach((m: any) => {
    if (m.metric_value.length > 0) {
      m.metric_group = ""
    }
  })
}
    this.showErrorPopUp = false;
    const storedProperties = localStorage.getItem('properties');
    if (storedProperties) {
      let properties = JSON.parse(storedProperties);
      let widgetNames = []; let widgetNames1 = [];
      // if (localStorage.getItem('TotalwidgetDetailss') != "" && localStorage.getItem('TotalwidgetDetailss') != null && localStorage.getItem('TotalwidgetDetailss') != undefined) {
      //   this._configService.WidgetLibSaveDataObject = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || "");
      if (this.isBrandDependent ==undefined) {
        if (!this.metric || this.metric.length < this.countOfMetricsTobeConfigured) {
  this.showErrorPopUp = true;
  this.popUpMessage = "Please select METRIC.";
  this.errorheaderTitle = "Error";
  return;
}

}
      // Check validation based on Brand Dependent/Independent selection
     else if (!this.isBrandDependent) {
        // Brand Independent - check for Audience and Brand selection
        const audienceItem = this.items.find((item: any) => item.id === 'Audience Drop down');
      
        
        if (audienceItem && (!audienceItem.checkedList || audienceItem.checkedList.length === 0)) {
          this.showErrorPopUp = true;
          this.popUpMessage = "Please select AUDIENCE.";
          this.errorheaderTitle = "Error";
          return;
        }
        
      
      } 
      else if(this.isBrandDependent){
         
          if (this.metric.length < this.countOfMetricsTobeConfigured) {
          this.showErrorPopUp = true;
          this.popUpMessage = "Please select METRIC.";
          this.errorheaderTitle = "Error";
          return;
        }
      }
      else {
        // Brand Dependent - check for Metric selection
        if (this.metric.length < this.countOfMetricsTobeConfigured) {
          this.showErrorPopUp = true;
          this.popUpMessage = "Please select METRIC.";
          this.errorheaderTitle = "Error";
          return;
        }
                 
      }

      
      if (this.isBrandDependent) {
        this.metric.forEach((m: any) => {
          if (m.metric_group == "" && m.metric_value.length <= 0) {
            this.showErrorPopUp = true;
            this.popUpMessage = "Please select METRIC.";
            this.errorheaderTitle = "Error";
            return;
          }
        })
        if(this.chartTitle == "spider/radar"){
          let metricount=0;
          if(this.metric[0].metric_value.length>0){
              this.metric[0].metric_value.forEach((m: any) => {
                  if(m.typeofmetric!=undefined){
                    metricount=metricount+1;
                  }
              })
          }
          if(this.metric[0].metric_group == "" && metricount<3){
            this.showErrorPopUp = true;
            this.popUpMessage = "Please select at least 3 metrics or one metric group";
            this.errorheaderTitle = "Error";
            return;
          }
        }
      }

    else {
  // Only validate if metric array exists and has items
  if (this.metric && this.metric.length > 0) {
    this.metric.forEach((m: any) => {
      if (m.metric_group == "" && m.metric_value.length <= 0) {
        this.showErrorPopUp = true;
        this.popUpMessage = "Please select METRIC.";
        this.errorheaderTitle = "Error";
        return;
      }
    })
  }
}


      // Prepare customization list
      const customization = Object.keys(properties).map((key) => ({
        key,
        value:properties[key]==null? properties[key]:properties[key].toString(),
      }));

      //adding new properties which doesnt exist in respective chart components 
      properties.infoText = this.customWidgetIcontext;
      properties.maxMetricLimit=this.maxMetricLimit;
      
      // Save BD/BI toggle state
      properties.bdBiToggle = this.isBrandDependent;
      
      const filteredItems = this._configCustomService.ChartPropertiesOptionSelection.filter(
        (item:any) =>
          item.Chart.trim().toLowerCase() === this.chartTitle.trim().toLowerCase() &&
        item.SnapshotType.replace(/\s+/g, '').toLowerCase()=== this._configCustomService.selectedSnapshotType.name.replace(/\s+/g, '').toLowerCase()
      );
      if(filteredItems){
      properties.trendlineOutputView=filteredItems[0]?.TrendLine;
      }
      
      // Merge checkbox properties into properties object
      properties = { ...properties, ...this.checkbox };
      
      if (properties.infoText != "") {
        this.checkbox["InfoText"] = properties.infoText;
      }
      
      // Create additionalGroup with only checkbox items (exclude toggle items like StackFormat)
      const { StackFormat, ...checkboxOnly } = this.checkbox;
      properties.additionalGroup = checkboxOnly;
      // if(this.chartproperties?.showLegend!=undefined && this.chartproperties?.showLegend!=null)
      //      properties.additionalGroup.showLegend=this.chartproperties?.showLegend;
      if (!this.isEditWidget) {

        // Get audience and brand data if Brand Dependent
        const audienceItem = this.items.find((item: any) => item.id === 'Audience Drop down');
        const brandItem = this.items.find((item: any) => item.id === 'Brand Drop down');
 const additionalKPI = this.items.find((item: any) => item.id === 'Additional KPI');
 const stackFormat = this.items.find((item: any) => item.id === 'Transpose');
 
 // Get the selected label from stackFormat where selected is true and value is enable
 let stackFormatLabel = '';
 if (stackFormat && stackFormat.options) {
   const selectedOption = stackFormat.options.find((opt: any) => opt.selected === true );
   stackFormatLabel = selectedOption ? selectedOption.label : '';
 }
 
        let CurrwidgetDetails: any = {
          "widget_name": this.widgetTitleText,
          "widgetchart_name": this.chartTitle,
          "widgetParentChartType": this.bucketName,
          "customizationProperties": JSON.stringify(properties),
          "previewChartPostion": 0
        };
        
if (this.isBrandDependent === undefined) {
 CurrwidgetDetails.metric = this.metric.map((item: any) => ({
            ...item,
            metric_value: [JSON.stringify(item.metric_value)]
          }));
           CurrwidgetDetails.brand = brandItem?.checkedList || [];
               CurrwidgetDetails.additionalKPI = this.additionalKPI && this.additionalKPI.length > 0 ? this.additionalKPI.map((item: any) => ({
          ...item,
          kpi_value: [JSON.stringify(item.kpi_value)]
        })) : [];
        if (stackFormatLabel && stackFormatLabel !== '') {
 
  CurrwidgetDetails.stackFormat = stackFormatLabel;
  CurrwidgetDetails.isBrandDependent = this.isBrandDependent; 
}
}
        // Add audience and brand if Brand Independent, otherwise add metric
    else if (this.isBrandDependent === false) {
        CurrwidgetDetails.audience = audienceItem?.checkedList || [];
        CurrwidgetDetails.brand = brandItem?.checkedList || [];
          CurrwidgetDetails.additionalKPI = this.additionalKPI && this.additionalKPI.length > 0 ? this.additionalKPI.map((item: any) => ({
          ...item,
          kpi_value: [JSON.stringify(item.kpi_value)]
        })) : [];
        if (stackFormatLabel && stackFormatLabel !== '') {
 CurrwidgetDetails.isBrandDependent = this.isBrandDependent; 
  CurrwidgetDetails.stackFormat = stackFormatLabel;
}
      } else {
        CurrwidgetDetails.metric = this.metric && this.metric.length > 0 ? this.metric.map((item: any) => ({
          ...item,
          metric_value: [JSON.stringify(item.metric_value)]
        })) : [];
        CurrwidgetDetails.brand = brandItem?.checkedList || [];
       
         CurrwidgetDetails.additionalKPI = this.additionalKPI && this.additionalKPI.length > 0 ? this.additionalKPI.map((item: any) => ({
          ...item,
          kpi_value: [JSON.stringify(item.kpi_value)]
        })) : [];
        if (stackFormatLabel && stackFormatLabel !== '') {
  CurrwidgetDetails.isBrandDependent = this.isBrandDependent; 
  CurrwidgetDetails.stackFormat = stackFormatLabel;
}
      }

        this._configCustomService.selectedSnapshotName = this.clientDetails.clientDetails.study;
        let objtoSave = {
          IsclientonSubmit: false,
          snapshotType: [{
            snapshotType_name: this._configCustomService.selectedSnapshotType.name,
            section: [{
              section_name: this._configCustomService.selectedSection,
              subsection: [{
                subsection_name: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
                widget_detail: [CurrwidgetDetails],
                page_details: []
              }]
            }]
          }],
          client_name: this._configService.clientName,
          snapshot_name: this.clientDetails.clientDetails.study,
           audienceCohortType: this._configService.audienceCohortType || ''
        }
        if (this._configCustomService.widgetSaveObjectCustom.length == 0) {
          this._configCustomService.widgetSaveObjectCustom.push(objtoSave);
        }
        else {
          let snaphottypes = this._configCustomService.widgetSaveObjectCustom.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
          if (snaphottypes) {
            let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
            if (snapshotType) {
              let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
              if (section) {
                let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
                if (subsection) {
                  widgetNames = subsection.widget_detail.map((widget: any) => widget.widget_name);
                  if (this.widgetTitleText == '' || this.widgetTitleText == null || widgetNames.includes(this.widgetTitleText) && this.chartTitle.toLowerCase() != "line chart") {
                    this.showErrorPopUp = true;
                    this.popUpMessage = "Widget name is empty or already exists. Please enter a valid widget name.";
                    this.errorheaderTitle = "Error";
                  }
                  else if (this.chartTitle.toLowerCase() != "line chart") {
                    subsection.widget_detail.push(CurrwidgetDetails);
                  }
                  //specifically for trendline chart 
                  else {
                    let widgetdetails = subsection.widget_detail.find((widget: any) => widget.widget_name == this.widgetTitleText);
                    if (widgetdetails) {
                      widgetdetails.widget_name = this.widgetTitleText;
                      widgetdetails.metric = this.metric;
                      widgetdetails.customizationProperties = JSON.stringify(properties);
                    }
                    else {
                      subsection.widget_detail.push(CurrwidgetDetails);

                    }
                  }
                }
                else {
                  section.subsection.push({
                    subsection_name: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
                    widget_detail: [CurrwidgetDetails],
                    page_details: []
                  });
                }
              }
              else {
                snapshotType.section.push({
                  section_name: this._configCustomService.selectedSection,
                  subsection: [{
                    subsection_name: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
                    widget_detail: [CurrwidgetDetails],
                    page_details: []
                  }]
                })
              }
            }
            else {
              snaphottypes.snapshotType.push({
                snapshotType_name: this._configCustomService.selectedSnapshotType.name,
                section: [{
                  section_name: this._configCustomService.selectedSection,
                  subsection: [{
                    subsection_name: (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection,
                    widget_detail: [CurrwidgetDetails],
                    page_details: []
                  }]
                }]
              })
            }
          }
          else {
            this._configCustomService.widgetSaveObjectCustom.push(objtoSave);
          }
        }
      }
      else {
        // Get audience and brand data if Brand Dependent
        const audienceItem = this.items.find((item: any) => item.id === 'Audience Drop down');
        const brandItem = this.items.find((item: any) => item.id === 'Brand Drop down');
 const additionalKPI = this.items.find((item: any) => item.id === 'Additional KPI');
  const stackFormat = this.items.find((item: any) => item.id === 'Transpose');
 
 // Get the selected label from stackFormat where selected is true and value is enable
 let stackFormatLabel = '';
 if (stackFormat && stackFormat.options) {
   const selectedOption = stackFormat.options.find((opt: any) => opt.selected === true );
   stackFormatLabel = selectedOption ? selectedOption.label : '';
 }
        let snaphottypes = this._configCustomService.widgetSaveObjectCustom.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
        if (snaphottypes) {
          let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType.name);
          if (snapshotType) {
            let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
            if (section) {
              let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
              if (subsection) {
                widgetNames = subsection.widget_detail.map(( widget: any) => widget.widget_name).filter((w: any) => w != this.userselectedchartdata?.widgetEditSelection?.widget_name);
                if (this.widgetTitleText == '' || this.widgetTitleText == null || widgetNames.includes(this.widgetTitleText)) {
                  this.showErrorPopUp = true;
                  this.popUpMessage = "Widget name is empty or already exists. Please enter a valid widget name.";
                  this.errorheaderTitle = "Error";
                }
                else {
                  let widgetdetails = subsection.widget_detail.find((widget: any) => widget.widget_name == this.userselectedchartdata?.widgetEditSelection?.widget_name);
                  if (widgetdetails) {
                    widgetdetails.widget_name = this.widgetTitleText;
                    
              widgetdetails.isBrandDependent = this.isBrandDependent;

if (this.isBrandDependent == undefined) {
  // Handle audience
  if (audienceItem?.checkedList && audienceItem.checkedList.length > 0) {
    widgetdetails.audience = audienceItem.checkedList;
  } else {
    delete widgetdetails.audience;
  }
  
  // Handle metric
  if (this.metric && this.metric.length > 0) {
    widgetdetails.metric = this.metric.map((item: any) => ({
      ...item,
      metric_value: [JSON.stringify(item.metric_value)]
    }));
  } else {
    delete widgetdetails.metric;
  }
  
  // Handle additionalKPI
  if (this.additionalKPI && this.additionalKPI.length > 0) {
    widgetdetails.additionalKPI = this.additionalKPI.map((item: any) => ({
      ...item,
      kpi_value: [JSON.stringify(item.kpi_value)]
    }));
  } else {
    widgetdetails.additionalKPI = [];
  }
  
  // Handle brand
  if (brandItem?.checkedList && brandItem.checkedList.length > 0) {
    widgetdetails.brand = brandItem.checkedList;
  } else {
    delete widgetdetails.brand;
  }
          if (stackFormatLabel && stackFormatLabel !== '') {
 
  widgetdetails.stackFormat = stackFormatLabel;
}
}
else if (!this.isBrandDependent) {
  // Brand Independent mode
  
  // Handle audience
  if (audienceItem?.checkedList && audienceItem.checkedList.length > 0) {
    widgetdetails.audience = audienceItem.checkedList;
  } else {
    delete widgetdetails.audience;
  }
  
  // Handle brand
  if (brandItem?.checkedList && brandItem.checkedList.length > 0) {
    widgetdetails.brand = brandItem.checkedList;
  } else {
    delete widgetdetails.brand;
  }
  
  // Handle additionalKPI
  if (this.additionalKPI && this.additionalKPI.length > 0) {
    widgetdetails.additionalKPI = this.additionalKPI.map((item: any) => ({
      ...item,
      kpi_value: [JSON.stringify(item.kpi_value)]
    }));
  } else {
    widgetdetails.additionalKPI = [];
  }
            if (stackFormatLabel && stackFormatLabel !== '') {
 
  widgetdetails.stackFormat = stackFormatLabel;
}
  // Remove metric if switching to Brand Independent
  delete widgetdetails.metric;
} else {
  // Brand Dependent mode
  
  // Handle metric
  if (this.metric && this.metric.length > 0) {
    widgetdetails.metric = this.metric.map((item: any) => ({
      ...item,
      metric_value: [JSON.stringify(item.metric_value)]
    }));
  } else {
    delete widgetdetails.metric;
  }
  
  // Handle additionalKPI
  if (this.additionalKPI && this.additionalKPI.length > 0) {
    widgetdetails.additionalKPI = this.additionalKPI.map((item: any) => ({
      ...item,
      kpi_value: [JSON.stringify(item.kpi_value)]
    }));
  } else {
      widgetdetails.additionalKPI = [];
  }
  
  // Handle brand
  if (brandItem?.checkedList && brandItem.checkedList.length > 0) {
    widgetdetails.brand = brandItem.checkedList;
  } else {
    delete widgetdetails.brand;
  }
            if (stackFormatLabel && stackFormatLabel !== '') {

  widgetdetails.stackFormat = stackFormatLabel;
}
  // Remove audience if switching to Brand Dependent
  delete widgetdetails.audience;
}

widgetdetails.customizationProperties = JSON.stringify(properties);

                  }
                }
              }

            }

          }
        }
      }

      if (!this.showErrorPopUp) {
        this._configCustomService.disablePreviewOnCustomizationSave = 1;//to disable preview
        this.showErrorPopUp = true;
        this.popUpMessage = "Saved Successfully.";
        this.errorheaderTitle = "Info";
        this.errorheaderTitle = "Info";
        this.fromSave = true;
        // this.goback();

        // this._configCustomService.saveCustomSnapshotWidgetLibrary(this._configCustomService.widgetSaveObjectCustom[0]).subscribe(
        //   (response: any) => {
        //     // response = JSON.parse(response.result);
        //     if (response.Data == 'Document updated successfully') {
        //       // Handle success here
        //       this.showErrorPopUp = true;
        //       this.popUpMessage = "Saved Successfully.";
        //       this.errorheaderTitle = "Info";
        //       this.fromSave = true;

        //     }
        //     else if (response.Data == 'Document inserted successfully') {
        //       this.showErrorPopUp = true;
        //       this.popUpMessage = "Saved Successfully.";
        //       this.errorheaderTitle = "Info";
        //       this.fromSave = true;

        //     }
        //     else {
        //       // Handle any non-200 response codes
        //       this.showErrorPopUp = true;
        //       this.popUpMessage = "Some Error Occured";
        //       this.errorheaderTitle = "Info";
        //       this.fromSave = false;
        //     }
        //   }
        // );
      }


    }
  }

  onCloseIconClick(closePopUp: string): void {
    if (closePopUp == 'false') {
      this.showErrorPopUp = false;
      if (this.fromSave) {
        this.goback();
      }
    }
    if (this.showConfirmationPopUp) {

      this.items.forEach((i: any) => {
        if (i.id === "Number of Levels") {
          i.selectedValue = this.previousnumberofFunnelLevels;
        }
      });
      let items = this.items;
      this.items = [];
      this._cdref.detectChanges();

      setTimeout(() => {
        this.items = items;
      }, 0)
      this._cdref.detectChanges();
    }
    this.showConfirmationPopUp = false;
  }

  togglemetriclev1Dropdown(options: any, lev1: any) {
    this.searchmetric = "";
    options.forEach((i: any) => {
      if (i == lev1) {
        lev1.isDropdownOpen = !lev1.isDropdownOpen;
      }
      else {
        i.isDropdownOpen = false;
      }
    })
    
    // Sort when opening dropdown: selected items first in selection order
    if (lev1.isDropdownOpen && lev1.Level2) {
      lev1.Level2.sort((a: any, b: any) => {
        const aSelected = (a.isSelected || a.checked) ? 1 : 0;
        const bSelected = (b.isSelected || b.checked) ? 1 : 0;
        const selectOrderA = a.selectOrder ?? 0;
        const selectOrderB = b.selectOrder ?? 0;

        // Selected items come first
        if (aSelected !== bSelected) {
          return bSelected - aSelected;
        }

        // Among selected items, sort by selection order (ascending)
        if (aSelected && bSelected && selectOrderA !== 0 && selectOrderB !== 0) {
          return selectOrderA - selectOrderB;
        }

        // Among unselected items, maintain original index order
        if (!aSelected && !bSelected) {
          return (a.index ?? 0) - (b.index ?? 0);
        }

        return 0;
      });
    }
  }

  toggleMetricDropdown(item: any, onmouseLeave: boolean) {
    this.searchmetric = "";
    
    // Sort when opening dropdown: selected items first in selection order
    if (!onmouseLeave && !item.showDropdown && item.options) {
      item.options.forEach((option: any) => {
        if (option.Level2 && Array.isArray(option.Level2)) {
          option.Level2.sort((a: any, b: any) => {
            const aSelected = (a.isSelected || a.checked) ? 1 : 0;
            const bSelected = (b.isSelected || b.checked) ? 1 : 0;
            const selectOrderA = a.selectOrder ?? 0;
            const selectOrderB = b.selectOrder ?? 0;

            // Selected items come first
            if (aSelected !== bSelected) {
              return bSelected - aSelected;
            }

            // Among selected items, sort by selection order (ascending)
            if (aSelected && bSelected && selectOrderA !== 0 && selectOrderB !== 0) {
              return selectOrderA - selectOrderB;
            }

            // Among unselected items, maintain original index order
            if (!aSelected && !bSelected) {
              return (a.index ?? 0) - (b.index ?? 0);
            }

            return 0;
          });
        }
      });
    }
    
    this._cdref.detectChanges();
    item.showDropdown = onmouseLeave ? false : !item.showDropdown;
    if (item.select == 3) {
      item.options.forEach((i: any) => {
        i.isDropdownOpen = false;
      })
    }
  }

  isAdditionalDropdownOpen: boolean = false;
  toggleAdditionaldropdown() {
    this.isAdditionalDropdownOpen = !this.isAdditionalDropdownOpen;
  }
  hasCheckboxItems(): boolean {
  return this.items && this.items.some((item: any) => item.inputType === 'checkbox');
}

  // resetSelections(item: any, options: any, lev1: any = []) {
  //   if (item.select != 3) {
  //     item.options = item.options.sort((a: any, b: any) => a.index - b.index);
  //     item.checkedList = [];
  //     options.forEach((o: any) => {
  //       o.checked = false;
  //       o.selectOrder = 0;
  //     })
  //   }
  //   else {
  //     lev1.Level2 = lev1.Level2.sort((a: any, b: any) => a.index - b.index);
  //     item.checkedList = [];
  //     lev1.Level2.forEach((o: any) => {
  //       o.isSelected = false;
  //       o.selectOrder = 0;
  //     })
  //   }
  //   this.metric = this.metric.filter((m: any) => m.metric_option !== item.customization);
  // }

  resetSelections(item: any, options: any, lev1: any = []) {

    let removeMetrics : any[] = [];
    

    
    
    if (item.select == 1) {
      item.options = item.options.sort((a: any, b: any) => a.index - b.index);
      options.forEach((o: any) => {
        o.checked = false;
        o.selectOrder = 0;
      })
      lev1.Level2.forEach( (lev2:any) => {
        if(lev2.checked){
          removeMetrics.push({
            option : lev2.option, 
            selectOrder : lev2.selectOrder
            
          })
        }
      })
    }
    else {
      if(lev1.option == "METRICS" || lev1.option == "CUSTOM METRICS"){

        lev1.Level2.forEach( (lev2:any) => {
          if(lev2.isSelected){
            removeMetrics.push({
              option : lev2.option, 
              selectOrder : lev2.selectOrder
              
            })
          }
        })
        let arrayofSelectedOrder: any[] = [];
        item.options.forEach((it:any)=>{
          if(it.option == lev1.option){
            it.Level2.forEach((lev2:any) => {
              if(lev2.isSelected){
                arrayofSelectedOrder.push(lev2.selectOrder);
                lev2.selectOrder = 0;
                lev2.isSelected = false;
                
              }
            })
          }
        })

        item.options.forEach((it:any)=>{
          if(it.option != lev1 && it.option != "METRIC GROUP"){
            it.Level2.forEach((lev2:any) => {
              if(lev2.isSelected){
                if(lev2.selectOrder){
                  let count = 0;
                  for( let i = 0 ; i <arrayofSelectedOrder.length ; i++ ){
                    if(lev2.selectOrder> arrayofSelectedOrder[i] ){
                      count++;
                    }
                  }
                  lev2.selectOrder = lev2.selectOrder-count;
                }
              }
            })
          }
        })
      }else{
        // Handle METRIC GROUP reset
        if(lev1.option == "METRIC GROUP"){
          item.options.forEach((it: any) => {
            if(it.option == lev1.option){
              it.Level2.forEach((lev2:any)=>{
                if(lev2.checked || lev2.isSelected){
                  removeMetrics.push({
                    option : lev2.option, 
                    selectOrder : lev2.selectOrder || 0
                  })
                }
                lev2.checked = false;
                lev2.isSelected = false;
                lev2.selectOrder = 0;
              })
            }
          })
          // Clear the metric_group in the metric array
          this.metric.forEach((m: any) => {
            if(m.metric_option == item.customization){
              m.metric_group = "";
            }
          });
        } else {
          item.options.forEach((it: any) => {
            if(it.option == lev1.option){
              it.Level2.forEach((lev2:any)=>{
                  lev2.checked = false;
                  lev2.selectOrder = 1;
              })
            }
          })
        }
      }
      lev1.Level2.forEach( (lev2:any) => {
          if(lev2.isSelected || lev2.checked){
            removeMetrics.push({
              option : lev2.option, 
              selectOrder : 0
              
            })
          }
        })
      // lev1.Level2 = lev1.Level2.sort((a: any, b: any) => a.index - b.index);
      // item.checkedList = [];
      // lev1.Level2.forEach((o: any) => {
      //   o.isSelected = false;
      //   o.selectOrder = 0;
      // })
    }

    item.checkedList = item.checkedList.filter( (it:any) => !removeMetrics.some((remove:any) => 
      remove.option === it.option && remove.selectOrder === it.selectOrder
    ));
    this.metric.forEach( (metric:any) => {
      if( metric.metric_option == item.customization){
        metric.metric_value = metric.metric_value.filter((metricValue: any) => item.checkedList.some((remove : any) => 
          remove.option === metricValue.option && remove.selectOrder === metricValue.selectOrder
        ))
      }
    });
    //this.metric = this.metric.filter((m: any) => m.metric_option !== item.customization);

  }

  // Rich Text Editor Methods
  formatText(command: string): void {
    if (this.richTextEditor) {
      this.richTextEditor.nativeElement.focus();
    }
    document.execCommand(command, false, '');
    // Update the model after formatting
    if (this.richTextEditor) {
      this.customWidgetIcontext = this.richTextEditor.nativeElement.innerHTML;
    }
  }

  insertLineBreak(): void {
    // Check character limit before allowing new line
    const currentText = this.getPlainTextFromHtml(this.customWidgetIcontext);
    if (currentText.length >= 300) {
      return; // Don't add line break if at character limit
    }

    if (this.richTextEditor) {
      this.richTextEditor.nativeElement.focus();
      
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        range.deleteContents();
        
        // Insert a line break
        const br = document.createElement('br');
        range.insertNode(br);
        
        // Create a text node with a zero-width space to position cursor properly
        const textNode = document.createTextNode('\u200B'); // Zero-width space
        range.setStartAfter(br);
        range.insertNode(textNode);
        
        // Position cursor after the text node
        range.setStartAfter(textNode);
        range.collapse(true);
        
        // Update selection
        selection.removeAllRanges();
        selection.addRange(range);
        
        // Update the model
        this.customWidgetIcontext = this.richTextEditor.nativeElement.innerHTML;
      }
    }
  }

  isFormatActive(command: string): boolean {
    try {
      return document.queryCommandState(command);
    } catch (e) {
      return false;
    }
  }

  updateButtonStates(): void {
    // This method is called to trigger change detection for button states
    // The actual state checking is done in isFormatActive()
  }

  onEditorFocus(): void {
    // Initialize content when editor is focused if empty
    if (this.richTextEditor && !this.richTextEditor.nativeElement.innerHTML.trim()) {
      this.richTextEditor.nativeElement.innerHTML = this.customWidgetIcontext || '';
    }
  }

  // Method to safely set editor content
  setEditorContent(content: string): void {
    if (this.richTextEditor) {
      this.richTextEditor.nativeElement.innerHTML = content || '';
      this.customWidgetIcontext = content || '';
    }
  }

  onRichTextChange(event: Event): void {
    const target = event.target as HTMLElement;
    let content = target.innerHTML;
    const originalContent = content;
    
    // Minimal cleanup: remove wrapper divs but keep their breaks; preserve consecutive <br>
    // Convert block div boundaries to single break only if they are empty
    content = content.replace(/<div>(?:\s|&nbsp;)*<\/div>/gi, '<br>');
    // Strip outer <div> tags but keep inner HTML
    content = content.replace(/<div>([\s\S]*?)<\/div>/gi, '$1');
    // Preserve paragraphs; only collapse completely empty ones
    content = content.replace(/<p>(?:\s|&nbsp;)*<\/p>/gi, '<br>');
    // Normalize excessive breaks: allow user intentional spacing up to 3
    content = content.replace(/(<br\s*\/>?){4,}/gi, '<br><br><br>');
    
    // Sanitize the content
    content = this.sanitizeHtmlContent(content);
    
    // Check character limit by converting HTML to plain text
    const textContent = this.getPlainTextFromHtml(content);
    
    if (textContent.length > 300) {
      // Prevent further input if character limit is exceeded
      event.preventDefault();
      return;
    }
    
    this.customWidgetIcontext = content;
    
    // Only update the editor content if there was significant cleanup
    // This prevents cursor jumping for minor formatting changes
    const significantChange = originalContent !== content && 
      Math.abs(originalContent.length - content.length) > 10;
    
    if (significantChange) {
      // Store current cursor position
      const selection = window.getSelection();
      let cursorPosition = 0;
      
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        cursorPosition = range.startOffset;
      }
      
      target.innerHTML = content;
      
      // Try to restore cursor position
      try {
        if (selection && target.firstChild) {
          const range = document.createRange();
          const textNode = target.firstChild.nodeType === Node.TEXT_NODE ? 
            target.firstChild : target.firstChild.firstChild;
          
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            const maxOffset = Math.min(cursorPosition, textNode.textContent?.length || 0);
            range.setStart(textNode, maxOffset);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }
      } catch (e) {
        // Ignore cursor restoration errors
      }
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const paste = (event.clipboardData || (window as any).clipboardData).getData('text');
    
    // Create a temporary div to clean the pasted content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = paste;
    const cleanText = tempDiv.textContent || tempDiv.innerText || '';
    
    // Check if adding pasted content would exceed character limit
    const currentText = this.getPlainTextFromHtml(this.customWidgetIcontext);
    if ((currentText + cleanText).length > 300) {
      const remainingChars = 300 - currentText.length;
      const truncatedText = cleanText.substring(0, remainingChars);
      document.execCommand('insertText', false, truncatedText);
    } else {
      document.execCommand('insertText', false, cleanText);
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    // Prevent Enter key from doing anything
    if (event.key === 'Enter') {
      event.preventDefault();
      return;
    }
    
    // Character limit enforcement for all keys except navigation and editing keys
    const target = event.target as HTMLElement;
    const currentText = this.getPlainTextFromHtml(target.innerHTML);
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'];
    
    if (currentText.length >= 300 && !allowedKeys.includes(event.key) && !event.ctrlKey) {
      event.preventDefault();
    }
  }

  getCharacterCount(): number {
    return this.getPlainTextFromHtml(this.customWidgetIcontext).length;
  }

  getCharacterCountClass(): string {
    const count = this.getCharacterCount();
    if (count > 280) return 'danger';
    if (count > 250) return 'warning';
    return '';
  }

  // Check if fixed value inputs should be shown
  shouldShowFixedValueInput(item: any): boolean {
    // Always show Fixed Value inputs if they exist in the items array
    // (they are only added when Quadrant Position is 'fixed')
    return true;
  }

  private getPlainTextFromHtml(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  // Sanitize HTML content to allow only safe formatting tags
  private sanitizeHtmlContent(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Allowed tags for formatting (lists removed per updated requirements)
    const allowedTags = ['b', 'strong', 'i', 'em', 'br', 'p'];
    const walker = document.createTreeWalker(
      tempDiv,
      NodeFilter.SHOW_ELEMENT,
      null
    );

    const elementsToRemove: Element[] = [];
    let node = walker.nextNode();
    
    while (node) {
      const element = node as Element;
      if (!allowedTags.includes(element.tagName.toLowerCase())) {
        elementsToRemove.push(element);
      }
      node = walker.nextNode();
    }

    // Remove disallowed elements but keep their text content
    elementsToRemove.forEach(element => {
      const textNode = document.createTextNode(element.textContent || '');
      element.parentNode?.replaceChild(textNode, element);
    });

    return tempDiv.innerHTML;
  }

  // Get sanitized HTML for display in output
  getFormattedInfoText(): SafeHtml {
    const sanitizedHtml = this.sanitizeHtmlContent(this.customWidgetIcontext);
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }

  // Method to display formatted text in snapshot output
  // This can be called from the output components to render the info text with formatting
  renderFormattedInfoText(): string {
    return this.sanitizeHtmlContent(this.customWidgetIcontext);
  }
}
function subscribe(arg0: (data: any) => void) {
  throw new Error('Function not implemented.');
}

